import { html } from 'lit'

// https://icons.getbootstrap.com/icons/building-fill/
export const buildingIcon = html`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  fill="currentColor"
  class="bi bi-building-fill"
  viewBox="0 0 16 16"
>
  <path
    d="M3 0a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h3v-3.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V16h3a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H3Zm1 2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3.5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5ZM4 5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM7.5 5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5Zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM4.5 8h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5Zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3.5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5Z"
  />
</svg>`

// https://icons.getbootstrap.com/icons/house-fill/
export const houseIcon = html`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  fill="currentColor"
  class="bi bi-house-fill"
  viewBox="0 0 16 16"
>
  <path
    d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5Z"
  />
  <path d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6Z" />
</svg>`

// https://icons.getbootstrap.com/icons/house/
export const houseIconOutline = html`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  fill="currentColor"
  class="bi bi-house"
  viewBox="0 0 16 16"
>
  <path
    d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5ZM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5 5 5Z"
  />
</svg>`

// https://icons.getbootstrap.com/icons/geo-alt-fill/
export const geotagIcon = html`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  class="bi bi-geo-alt-fill"
  viewBox="0 0 16 16"
>
  <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
</svg>`

// https://icons.getbootstrap.com/icons/megaphoneIcon-fill/
export const megaphoneIcon = html`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  class="bi bi-megaphone-fill"
  viewBox="0 0 16 16"
>
  <path
    d="M13 2.5a1.5 1.5 0 0 1 3 0v11a1.5 1.5 0 0 1-3 0v-11zm-1 .724c-2.067.95-4.539 1.481-7 1.656v6.237a25.222 25.222 0 0 1 1.088.085c2.053.204 4.038.668 5.912 1.56V3.224zm-8 7.841V4.934c-.68.027-1.399.043-2.008.053A2.02 2.02 0 0 0 0 7v2c0 1.106.896 1.996 1.994 2.009a68.14 68.14 0 0 1 .496.008 64 64 0 0 1 1.51.048zm1.39 1.081c.285.021.569.047.85.078l.253 1.69a1 1 0 0 1-.983 1.187h-.548a1 1 0 0 1-.916-.599l-1.314-2.48a65.81 65.81 0 0 1 1.692.064c.327.017.65.037.966.06z"
  />
</svg>`

// Brand logo generated from image
export const ejmLogo = html`<svg
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  viewBox="0 0 236.42 88.15"
>
  <defs>
    <style>
      .cls-1 {
        fill: url(#linear-gradient);
      }

      .cls-2 {
        fill: #dd6e2d;
      }

      .cls-3 {
        fill: url(#linear-gradient-8);
      }

      .cls-4 {
        fill: url(#linear-gradient-9);
      }

      .cls-5 {
        fill: url(#linear-gradient-3);
      }

      .cls-6 {
        fill: url(#linear-gradient-4);
      }

      .cls-7 {
        fill: url(#linear-gradient-2);
      }

      .cls-8 {
        fill: url(#linear-gradient-6);
      }

      .cls-9 {
        fill: url(#linear-gradient-7);
      }

      .cls-10 {
        fill: url(#linear-gradient-5);
      }

      .cls-11 {
        fill: url(#linear-gradient-55);
      }

      .cls-12 {
        fill: url(#linear-gradient-53);
      }

      .cls-13 {
        fill: url(#linear-gradient-54);
      }

      .cls-14 {
        fill: url(#linear-gradient-51);
      }

      .cls-15 {
        fill: url(#linear-gradient-52);
      }

      .cls-16 {
        fill: url(#linear-gradient-50);
      }

      .cls-17 {
        fill: url(#linear-gradient-41);
      }

      .cls-18 {
        fill: url(#linear-gradient-40);
      }

      .cls-19 {
        fill: url(#linear-gradient-43);
      }

      .cls-20 {
        fill: url(#linear-gradient-42);
      }

      .cls-21 {
        fill: url(#linear-gradient-45);
      }

      .cls-22 {
        fill: url(#linear-gradient-46);
      }

      .cls-23 {
        fill: url(#linear-gradient-44);
      }

      .cls-24 {
        fill: url(#linear-gradient-49);
      }

      .cls-25 {
        fill: url(#linear-gradient-47);
      }

      .cls-26 {
        fill: url(#linear-gradient-48);
      }

      .cls-27 {
        fill: url(#linear-gradient-14);
      }

      .cls-28 {
        fill: url(#linear-gradient-18);
      }

      .cls-29 {
        fill: url(#linear-gradient-22);
      }

      .cls-30 {
        fill: url(#linear-gradient-20);
      }

      .cls-31 {
        fill: url(#linear-gradient-21);
      }

      .cls-32 {
        fill: url(#linear-gradient-23);
      }

      .cls-33 {
        fill: url(#linear-gradient-15);
      }

      .cls-34 {
        fill: url(#linear-gradient-19);
      }

      .cls-35 {
        fill: url(#linear-gradient-16);
      }

      .cls-36 {
        fill: url(#linear-gradient-17);
      }

      .cls-37 {
        fill: url(#linear-gradient-13);
      }

      .cls-38 {
        fill: url(#linear-gradient-12);
      }

      .cls-39 {
        fill: url(#linear-gradient-10);
      }

      .cls-40 {
        fill: url(#linear-gradient-11);
      }

      .cls-41 {
        fill: url(#linear-gradient-27);
      }

      .cls-42 {
        fill: url(#linear-gradient-24);
      }

      .cls-43 {
        fill: url(#linear-gradient-26);
      }

      .cls-44 {
        fill: url(#linear-gradient-38);
      }

      .cls-45 {
        fill: url(#linear-gradient-35);
      }

      .cls-46 {
        fill: url(#linear-gradient-37);
      }

      .cls-47 {
        fill: url(#linear-gradient-34);
      }

      .cls-48 {
        fill: url(#linear-gradient-39);
      }

      .cls-49 {
        fill: url(#linear-gradient-36);
      }

      .cls-50 {
        fill: url(#linear-gradient-25);
      }

      .cls-51 {
        fill: url(#linear-gradient-28);
      }

      .cls-52 {
        fill: url(#linear-gradient-29);
      }

      .cls-53 {
        fill: url(#linear-gradient-33);
      }

      .cls-54 {
        fill: url(#linear-gradient-30);
      }

      .cls-55 {
        fill: url(#linear-gradient-32);
      }

      .cls-56 {
        fill: url(#linear-gradient-31);
      }
    </style>
    <linearGradient
      id="linear-gradient"
      x1="417.01"
      y1="-84.51"
      x2="417.01"
      y2="-114.47"
      gradientTransform="translate(-272 -52.13) scale(1 -1)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#faf1d8" />
      <stop offset=".5" stop-color="#f2e7cd" />
      <stop offset="1" stop-color="#d2c2a5" />
    </linearGradient>
    <linearGradient
      id="linear-gradient-2"
      x1="375.99"
      y1="-92.83"
      x2="375.99"
      y2="-115.1"
      xlink:href="#linear-gradient"
    />
    <linearGradient
      id="linear-gradient-3"
      x1="443.63"
      y1="-92.92"
      x2="443.63"
      y2="-114.68"
      xlink:href="#linear-gradient"
    />
    <linearGradient
      id="linear-gradient-4"
      x1="502.06"
      y1="-93.47"
      x2="502.06"
      y2="-119.84"
      xlink:href="#linear-gradient"
    />
    <linearGradient
      id="linear-gradient-5"
      x1="465.47"
      y1="-93.1"
      x2="465.47"
      y2="-115.05"
      xlink:href="#linear-gradient"
    />
    <linearGradient
      id="linear-gradient-6"
      x1="477.93"
      y1="-86.03"
      x2="477.93"
      y2="-114.71"
      xlink:href="#linear-gradient"
    />
    <linearGradient
      id="linear-gradient-7"
      x1="362.86"
      y1="-84.49"
      x2="362.86"
      y2="-114.67"
      xlink:href="#linear-gradient"
    />
    <linearGradient
      id="linear-gradient-8"
      x1="395.29"
      y1="-84.51"
      x2="395.29"
      y2="-114.55"
      xlink:href="#linear-gradient"
    />
    <linearGradient
      id="linear-gradient-9"
      x1="490.36"
      y1="-93.49"
      x2="490.36"
      y2="-114.67"
      xlink:href="#linear-gradient"
    />
    <linearGradient
      id="linear-gradient-10"
      x1="455.21"
      y1="-93.37"
      x2="455.21"
      y2="-114.54"
      xlink:href="#linear-gradient"
    />
    <linearGradient
      id="linear-gradient-11"
      x1="387.59"
      y1="-93.37"
      x2="387.59"
      y2="-114.54"
      xlink:href="#linear-gradient"
    />
    <linearGradient
      id="linear-gradient-12"
      x1="432.41"
      y1="-93.34"
      x2="432.41"
      y2="-114.58"
      xlink:href="#linear-gradient"
    />
    <linearGradient
      id="linear-gradient-13"
      x1="387.49"
      y1="-85.52"
      x2="387.49"
      y2="-89.54"
      gradientTransform="translate(-272 -52.13) scale(1 -1)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#faf1d8" />
      <stop offset="1" stop-color="#f2e7cd" />
      <stop offset="1" stop-color="#d2c2a5" />
    </linearGradient>
    <linearGradient
      id="linear-gradient-14"
      x1="455.16"
      y1="-85.53"
      x2="455.16"
      y2="-89.53"
      gradientTransform="translate(-272 -52.13) scale(1 -1)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#faf1d8" />
      <stop offset=".99" stop-color="#f2e7cd" />
      <stop offset="1" stop-color="#d2c2a5" />
    </linearGradient>
    <linearGradient
      id="linear-gradient-15"
      x1="432.34"
      y1="-85.56"
      x2="432.34"
      y2="-89.36"
      xlink:href="#linear-gradient-13"
    />
    <linearGradient
      id="linear-gradient-16"
      x1="433.95"
      y1="-98.23"
      x2="433.95"
      y2="-106.19"
      xlink:href="#linear-gradient"
    />
    <linearGradient
      id="linear-gradient-17"
      x1="433.9"
      y1="-88.12"
      x2="433.9"
      y2="-89.33"
      xlink:href="#linear-gradient"
    />
    <linearGradient
      id="linear-gradient-18"
      x1="411.1"
      y1="-94.57"
      x2="411.1"
      y2="-95.16"
      xlink:href="#linear-gradient"
    />
    <linearGradient
      id="linear-gradient-19"
      x1="410.95"
      y1="-110.54"
      x2="410.95"
      y2="-110.76"
      xlink:href="#linear-gradient"
    />
    <linearGradient
      id="linear-gradient-20"
      x1="433.96"
      y1="-95.08"
      x2="433.96"
      y2="-95.35"
      xlink:href="#linear-gradient"
    />
    <linearGradient
      id="linear-gradient-21"
      x1="433.8"
      y1="-93.34"
      x2="433.8"
      y2="-93.39"
      xlink:href="#linear-gradient"
    />
    <linearGradient
      id="linear-gradient-22"
      x1="396.75"
      y1="-114.42"
      x2="396.75"
      y2="-114.44"
      xlink:href="#linear-gradient"
    />
    <linearGradient
      id="linear-gradient-23"
      x1="363.51"
      y1="-84.49"
      x2="363.51"
      y2="-84.5"
      xlink:href="#linear-gradient"
    />
    <linearGradient
      id="linear-gradient-24"
      x1="479.49"
      y1="-90.02"
      x2="479.49"
      y2="-90.05"
      xlink:href="#linear-gradient"
    />
    <linearGradient
      id="linear-gradient-25"
      x1="479.48"
      y1="-87.74"
      x2="479.48"
      y2="-87.77"
      xlink:href="#linear-gradient"
    />
    <linearGradient
      id="linear-gradient-26"
      x1="393.6"
      y1="-107.97"
      x2="393.6"
      y2="-107.99"
      xlink:href="#linear-gradient"
    />
    <linearGradient
      id="linear-gradient-27"
      x1="433.95"
      y1="-93.84"
      x2="433.95"
      y2="-93.85"
      xlink:href="#linear-gradient"
    />
    <linearGradient
      id="linear-gradient-28"
      x1="479.46"
      y1="-86.22"
      x2="479.46"
      y2="-86.24"
      xlink:href="#linear-gradient"
    />
    <linearGradient
      id="linear-gradient-29"
      x1="327.57"
      y1="-79.35"
      x2="327.57"
      y2="-103.19"
      gradientTransform="translate(-272 -52.13) scale(1 -1)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#e2a72c" />
      <stop offset="1" stop-color="#c3712b" />
    </linearGradient>
    <linearGradient
      id="linear-gradient-30"
      x1="316.63"
      y1="-79.28"
      x2="316.63"
      y2="-79.28"
      xlink:href="#linear-gradient-29"
    />
    <linearGradient
      id="linear-gradient-31"
      x1="316.39"
      y1="-79.14"
      x2="316.39"
      y2="-79.28"
      xlink:href="#linear-gradient-29"
    />
    <linearGradient
      id="linear-gradient-32"
      x1="316.77"
      y1="-79.28"
      x2="316.77"
      y2="-79.35"
      xlink:href="#linear-gradient-29"
    />
    <linearGradient
      id="linear-gradient-33"
      x1="298.92"
      y1="-123.44"
      x2="298.92"
      y2="-138.43"
      xlink:href="#linear-gradient-29"
    />
    <linearGradient
      id="linear-gradient-34"
      x1="319.29"
      y1="-122.7"
      x2="319.29"
      y2="-126.82"
      xlink:href="#linear-gradient-29"
    />
    <linearGradient
      id="linear-gradient-35"
      x1="283.95"
      y1="-120.32"
      x2="283.95"
      y2="-132.15"
      xlink:href="#linear-gradient-29"
    />
    <linearGradient
      id="linear-gradient-36"
      x1="295.69"
      y1="-120.05"
      x2="295.69"
      y2="-120.06"
      xlink:href="#linear-gradient-29"
    />
    <linearGradient
      id="linear-gradient-37"
      x1="310.47"
      y1="-136.53"
      x2="310.47"
      y2="-140.26"
      xlink:href="#linear-gradient-29"
    />
    <linearGradient
      id="linear-gradient-38"
      x1="286.33"
      y1="-106.5"
      x2="286.33"
      y2="-131.29"
      xlink:href="#linear-gradient-29"
    />
    <linearGradient
      id="linear-gradient-39"
      x1="274.56"
      y1="-106.48"
      x2="274.56"
      y2="-106.53"
      xlink:href="#linear-gradient-29"
    />
    <linearGradient
      id="linear-gradient-40"
      x1="274.57"
      y1="-106.52"
      x2="274.57"
      y2="-106.53"
      xlink:href="#linear-gradient-29"
    />
    <linearGradient
      id="linear-gradient-41"
      x1="304.43"
      y1="-79.17"
      x2="304.43"
      y2="-79.26"
      xlink:href="#linear-gradient-29"
    />
    <linearGradient
      id="linear-gradient-42"
      x1="310.47"
      y1="-125.05"
      x2="310.47"
      y2="-134.04"
      xlink:href="#linear-gradient-29"
    />
    <linearGradient
      id="linear-gradient-43"
      x1="293.3"
      y1="-79.3"
      x2="293.3"
      y2="-103.15"
      xlink:href="#linear-gradient-29"
    />
    <linearGradient
      id="linear-gradient-44"
      x1="289.96"
      y1="-95.31"
      x2="289.96"
      y2="-95.8"
      xlink:href="#linear-gradient-29"
    />
    <linearGradient
      id="linear-gradient-45"
      x1="301.67"
      y1="-122.69"
      x2="301.67"
      y2="-126.82"
      xlink:href="#linear-gradient-29"
    />
    <linearGradient
      id="linear-gradient-46"
      x1="347.95"
      y1="-95.98"
      x2="347.95"
      y2="-95.98"
      xlink:href="#linear-gradient-29"
    />
    <linearGradient
      id="linear-gradient-47"
      x1="333.56"
      y1="-114.2"
      x2="333.56"
      y2="-114.21"
      xlink:href="#linear-gradient-29"
    />
    <linearGradient
      id="linear-gradient-48"
      x1="272.37"
      y1="-95.57"
      x2="272.37"
      y2="-95.6"
      xlink:href="#linear-gradient-29"
    />
    <linearGradient
      id="linear-gradient-49"
      x1="272.35"
      y1="-95.56"
      x2="272.35"
      y2="-95.57"
      xlink:href="#linear-gradient-29"
    />
    <linearGradient
      id="linear-gradient-50"
      x1="310.39"
      y1="-52.14"
      x2="310.39"
      y2="-114.06"
      xlink:href="#linear-gradient-29"
    />
    <linearGradient
      id="linear-gradient-51"
      x1="310.47"
      y1="-52.13"
      x2="310.47"
      y2="-52.14"
      xlink:href="#linear-gradient-29"
    />
    <linearGradient
      id="linear-gradient-52"
      x1="334.57"
      y1="-106.46"
      x2="334.57"
      y2="-131.35"
      xlink:href="#linear-gradient-29"
    />
    <linearGradient
      id="linear-gradient-53"
      x1="322.02"
      y1="-123.43"
      x2="322.02"
      y2="-138.43"
      xlink:href="#linear-gradient-29"
    />
    <linearGradient
      id="linear-gradient-54"
      x1="336.96"
      y1="-120.32"
      x2="336.96"
      y2="-132.12"
      xlink:href="#linear-gradient-29"
    />
    <linearGradient
      id="linear-gradient-55"
      x1="289.41"
      y1="-79.64"
      x2="289.41"
      y2="-80.46"
      xlink:href="#linear-gradient-29"
    />
  </defs>
  <g id="elkhart">
    <g>
      <path
        class="cls-2"
        d="m193.37,75.04c.58-.49,1.15-1,1.75-1.47.78-.61,1.61-1.17,2.36-1.81.3-.25.56-.64.65-1.02.19-.83,1.05-1.4,1.89-1.14.49.15.55.91.14,1.36-.47.51-.91,1.04-1.42,1.63.82-.71,1.55-1.37,2.32-1.97.51-.4,1.07-.76,1.65-1.08.43-.24,1.06.22.97.85-.11.75-.42,1.49-.76,2.19-.36.75-.86,1.43-1.37,2.27,1.97-.78,2.99-2.73,5.17-3.27.1-.3.28-.83.49-1.45-.29-.02-.56,0-.8-.07-.23-.07-.57-.21-.62-.38-.05-.2.11-.58.28-.67.32-.17.73-.26,1.1-.25.7,0,1.1-.22,1.14-.96.03-.61.28-1.16.96-1.25.34-.04.78.09,1.03.31.13.11-.03.58-.12.87-.06.18-.23.34-.45.64.5.03.86,0,1.17.09.27.08.49.31.72.48-.21.25-.37.61-.63.71-.37.14-.82.09-1.24.1-.57,0-.92.27-1.14.78-.23.55-.54,1.07-.79,1.61-.6,1.29-1.18,2.6-1.78,3.89-.19.42-.36.85-.61,1.23-.14.21-.43.33-.83.62-.17-2.2,1.65-3.54,1.68-5.66-.96.76-1.86,1.44-2.71,2.16-.78.65-1.48,1.4-2.3,2-.35.25-.92.22-1.39.31-.08-.11-.16-.22-.23-.33.9-1.73,1.8-3.45,2.7-5.18-.05-.05-.09-.09-.14-.14-.32.18-.7.3-.93.55-1.37,1.44-2.69,2.91-4.05,4.36-.35.37-.6,1.08-1.25.77-.17-.08-.09-.92.06-1.36.17-.5.54-.93.82-1.4.14-.24.23-.49.35-.74-.08-.06-.16-.12-.25-.18-.77.68-1.53,1.37-2.31,2.05-.65.56-1.3,1.11-1.98,1.61-.18.13-.5.09-.76.13-.04-.3-.14-.6-.1-.89.05-.4.2-.8.31-1.2l-.19-.1c-.74.59-1.46,1.21-2.23,1.76-.32.22-.9.49-1.13.35-.31-.18-.56-.74-.53-1.11.09-.97.35-1.93.56-3-.87.46-1.57.03-2.28-.74-.15.4-.24.64-.32.88-.7,2.05-2.13,3.39-4.24,4.01-1.31.39-2.3-.52-2.06-1.82.06-.34.16-.67.29-1.21-.66.33-1.18.56-1.67.84-1.43.81-2.8,1.74-4.3,2.42-.76.35-1.73.33-2.6.32-.28,0-.69-.49-.8-.83-.36-1.13.36-2.03.97-2.81,1.28-1.62,2.65-3.19,4.1-4.66.94-.95,2.1-1.67,3.15-2.51.32-.26.57-.62.92-.8.4-.2.91-.41,1.33-.34.58.09.85.54.63,1.17-.07.19.02.43,0,.65-.13,1.22-.51,1.56-1.75,1.34-1.08-.2-1.96.3-2.56.91-1.83,1.85-3.52,3.84-5.23,5.8-.19.21-.33.75-.22.85.22.2.67.34.95.26.68-.19,1.35-.47,1.98-.79,1.86-.94,3.71-1.9,5.55-2.87.38-.2.74-.47,1.08-.74.93-.76,1.81-1.59,2.77-2.31,1.05-.79,1.89-.51,2.44.67.17.36.39.75.69.99.94.75,1.99.46,2.52-.62.05-.1.09-.2.13-.3.17-.45.41-.81.98-.63.49.15.84.93.56,1.35-.46.71-.94,1.43-1.55,2.01-.66.64-.83,1.38-1,2.16.06.05.13.1.19.15.53-.45,1.07-.88,1.59-1.34.57-.5,1.09-1.09,1.7-1.53.84-.61,1.41-1.36,1.81-2.29.1-.23.48-.52.68-.48.36.05.75.27.98.54.12.14-.01.6-.17.82-.9,1.22-1.85,2.41-2.78,3.6.1.09.2.17.3.26h0Zm-12.23,1c2.03-.51,3.47-1.34,3.59-3.39.02-.36-.16-.74-.25-1.1-.38.1-.8.12-1.12.31-1.2.74-1.79,1.94-2.32,3.16-.11.26.05.63.09,1.02h0Z"
      />
      <path
        class="cls-2"
        d="m145.05,75.36c-.58.43-1.11.91-1.72,1.26-.32.18-.76.16-1.14.23-.06-.39-.28-.83-.17-1.15.39-1.07.91-2.1,1.37-3.14.18-.43.32-.87.48-1.31-.1-.07-.21-.13-.31-.19-.84.83-1.74,1.61-2.49,2.51-.69.84-1.18,1.83-1.81,2.71-.19.26-.57.4-.87.59-.03-.34-.19-.73-.08-1.02.71-1.76,1.53-3.48,2.21-5.25.55-1.43.95-2.92,1.46-4.37.08-.23.38-.54.59-.55.44-.01.97.04,1.29.28.54.41.36,1.13-.06,1.73-.82,1.17-1.53,2.4-2.28,3.62-.02.03.04.09.08.19.66-.48,1.32-.94,1.95-1.44.53-.43,1.17-.78,1.69-.25.53.54.22,1.24-.14,1.87-.7,1.22-1.36,2.47-2.04,3.7.05.06.11.12.16.18.34-.19.72-.32,1-.56,1.04-.9,2.03-1.85,3.08-2.74,1.04-.89,2.12-1.74,3.21-2.58.48-.37,1-.4,1.53-.02.12.09.36.12.51.08.7-.23,1.02.27,1.21.71.09.2-.2.67-.45.89-1.19,1.05-1.72,2.45-2.37,3.79l.21.18c1.2-.75,2.43-1.46,3.57-2.27.46-.33.83-.86,1.05-1.38.14-.33-.09-.8-.17-1.21-.03-.15-.17-.4-.15-.42.53-.28,1.05-.58,1.62-.75.15-.04.46.33.66.54.14.15.23.36.4.64.66-.91,1.56-1.15,2.59-1.07.51.04,1.4,1.16,1.35,1.72-.06.65-.91,1.25-1.62,1.05-.25-.07-.49-.39-.62-.65-.36-.76-.57-.83-1.22-.25-1.53,1.35-2.55,3.05-3.43,4.85-.17.34-.28.72-.49,1.03-.12.18-.38.26-.57.38-.09-.21-.3-.45-.25-.62.18-.65.45-1.28.69-1.91.12-.32.27-.62.26-1.06-.82.53-1.64,1.05-2.44,1.6-.43.29-.79.71-1.25.95-.39.2-.88.2-1.32.3-.05-.38-.14-.76-.13-1.14.01-.31.15-.63.07-1.08-.46.42-.91.86-1.38,1.27-.56.48-1.1.99-1.72,1.38-.18.11-.75-.09-.91-.3-.31-.43-.45-.97-.68-1.54h0Zm1.51.22c.33,0,.45.04.49,0,1.42-1.28,2.85-2.56,4.25-3.86.08-.08.1-.33.04-.43-.08-.1-.3-.18-.43-.16-.27.05-.55.14-.77.28-1.24.8-2.28,1.79-3.09,3-.21.31-.3.71-.48,1.17Z"
      />
      <path
        class="cls-2"
        d="m118.55,75.63c.89-.21,1.84-.29,2.66-.65,2.6-1.15,5.18-2.37,7.71-3.67.42-.21.6-.92.82-1.43.55-1.26,1.02-2.56,1.62-3.79.12-.25.68-.4,1.04-.42.61-.04,1,.38,1.08.94.05.32-.04.73-.22.99-.21.3-.66.42-.9.71-.42.51-.79,1.07-1.12,1.65-.82,1.43-1.63,2.87-2.41,4.33-.35.65-.57,1.38-.95,2.01-.14.23-.56.29-.86.43-.07-.3-.27-.64-.18-.88.31-.84.71-1.64,1.08-2.46.11-.26.23-.51.35-.77-.06-.05-.11-.1-.17-.15-1.1.61-2.18,1.26-3.3,1.82-1.95.98-3.9,1.96-5.91,2.81-.52.22-1.72.1-1.82-.15-.24-.64-.22-1.5.02-2.16.58-1.6,2.12-2.39,3.42-3.35.17-.12.34-.24.61-.44-.4-.18-.69-.3-.98-.43-.81-.37-.98-1.13-.4-1.77,1.64-1.84,3.78-2.81,6.17-3.29.59-.12,1.4-.15,1.56.51.08.32-.57.89-1,1.21-.36.27-.92.58-1.16-.25-.03-.12-.45-.26-.59-.19-1.12.56-2.23,1.15-3.31,1.77-.13.07-.22.47-.15.56.18.21.47.45.72.45.71,0,1.43-.1,2.14-.2.42-.05.88-.24.98.38.09.54-.34.64-.76.78-2.23.78-4.19,1.98-5.73,3.76-.22.25-.22.68-.32,1.03.08.11.15.21.23.32h0Z"
      />
      <path
        class="cls-2"
        d="m113.18,66.02c-.38.19-.74.25-.84.44-.65,1.19-1.25,2.41-1.83,3.63-.04.08.28.45.44.45.55,0,1.1-.1,1.66-.14.35-.02.71,0,1.07,0,.02.11.04.21.06.32-.19.11-.37.27-.57.32-.83.18-1.68.32-2.51.49-.62.13-1.11.41-1.4,1.01-.51,1.07-1.04,2.14-1.63,3.17-.28.49-.72.88-1.21,1.47-.5-1.18.46-1.65.62-2.36.17-.76.43-1.5.67-2.33-.88.22-1.79.53-2.55-.49-.19.28-.4.47-.46.69-.54,2.1-2.06,3.28-3.99,4.04-.72.28-1.58.26-2.1-.36-.5-.6-.41-1.34-.02-2.05,1.11-2.03,2.73-3.58,4.69-4.81.88-.55,1.66-.26,2.1.69.5,1.08.64,1.22,1.48,1.55.55-.32,1-.54,1.41-.83.28-.2.57-.44.71-.73.6-1.15,1.1-2.36,1.74-3.5.62-1.11,1.7-1.54,2.95-1.32.7.13.99.67.91,1.66-.05.65-.53.79-1.05.82-.45.02-.77-.12-.57-.69.1-.29.12-.62.21-1.15h0Zm-9.52,6.42c.01-.75-.36-1.11-.96-.93-1.09.33-2.98,2.7-2.96,3.81,0,.23.33.64.5.64,1.68-.06,3.4-1.86,3.43-3.52h0Z"
      />
      <path
        class="cls-2"
        d="m211.34,75.13c1.65-1.4,3.36-2.76,4.93-4.25.38-.36.36-1.18,1.19-.93.35.11.7.4.88.71.09.16-.15.55-.31.79-.22.34-.54.62-.77.96-.75,1.06-1.57,2.09-2.19,3.22-1.17,2.14-2.21,4.35-3.32,6.52-.09.18-.28.32-.42.48-.16-.2-.38-.37-.45-.6-.05-.18.05-.43.15-.62,1.04-2.13,2.09-4.25,3.12-6.38.16-.34.22-.73.32-1.1-.08-.05-.15-.1-.23-.15-.9.7-1.81,1.4-2.71,2.1-.32.25-.62.55-.97.76-.2.12-.53.18-.72.09-.19-.09-.38-.39-.39-.61-.02-.36,0-.77.17-1.1.76-1.53,1.55-3.05,2.39-4.54.19-.34.56-.66.93-.8.15-.06.68.37.72.62.06.39-.04.9-.26,1.24-.73,1.14-1.55,2.22-2.33,3.33.09.09.19.17.28.26h0Z"
      />
      <path
        class="cls-2"
        d="m133.92,72.37c1.06-.12,1.64-.73,2.28-1.29.27-.24.67-.4,1.03-.44.14-.01.51.5.45.64-.14.33-.43.66-.74.84-.59.34-1.24.58-1.88.84-.5.2-.54.53-.26.9.57.72,1.18,1.41,1.76,2.12.14.18.23.39.35.59-.24.1-.49.26-.74.27-.19.01-.43-.13-.57-.27-.65-.66-1.27-1.35-1.89-2.04-.61-.67-.99-.67-1.43.12-.57,1.03-1.08,2.08-1.62,3.13-.14.27-.24.57-.44.78-.17.19-.46.29-.69.43-.03-.25-.16-.54-.08-.75.26-.68.6-1.34.9-2,.61-1.36,1.19-2.73,1.84-4.08.57-1.19,1.21-2.35,1.86-3.49.31-.54,1.21-.74,1.53-.43.4.39.37,1.46-.02,1.86-.51.53-1.01,1.07-1.48,1.63-.11.13-.1.35-.17.64h0Z"
      />
      <path
        class="cls-2"
        d="m164.28,70.05c-.47-.02-.75.02-1-.06-.23-.07-.56-.25-.58-.42-.02-.2.18-.5.37-.64.18-.13.48-.19.71-.16.98.11,1.41-.31,1.54-1.23.11-.73,1.08-1.17,1.73-.81.16.09.26.46.22.67-.06.3-.28.58-.51.99.42.03.77,0,1.08.09.26.08.48.32.71.49-.21.25-.42.5-.64.74-.01.02-.06.02-.08.02-2.21-.41-2.53,1.37-3.22,2.68-.64,1.22-1.2,2.48-1.79,3.74-.13.29-.13.65-.32.9-.21.28-.55.46-.84.68-.08-.28-.19-.56-.23-.85-.02-.15.06-.32.12-.47.4-.92.81-1.83,1.2-2.75.49-1.15.96-2.3,1.5-3.61h0Z"
      />
    </g>
  </g>
  <g id="JailMin">
    <g>
      <path
        class="cls-1"
        d="m138.95,58.63c0,1.06-.03,2.11-.02,3.16,0,.55,0,.75,0,.75-.63-.03-2.11,0-2.84,0,0-.31-.02-.66-.03-.92-.02-9.53-.03-19.05-.05-28.57,0-.64.18-.88.81-.84.74.04,1.49.07,2.22,0,.7-.08.86.36.97.87.58,2.71,1.16,5.42,1.72,8.14.5,2.46.96,4.93,1.49,7.38.3,1.43.71,2.84,1.04,4.27.22.95.37,1.91.55,2.86.11,0,.21,0,.31.01.2-.75.42-1.49.58-2.25.56-2.51,1.1-5.02,1.64-7.53.68-3.14,1.37-6.27,2.03-9.41.25-1.19.42-2.39.68-3.57.05-.24.38-.57.6-.58,1.13-.06,2.26-.03,3.38-.03v30.03h-2.86v-19.89c-.07,0-.14,0-.21-.01-.26,1.01-.55,2.02-.78,3.04-.3,1.38-.54,2.78-.84,4.16-.51,2.33-1.04,4.65-1.57,6.97-.4,1.74-.81,3.49-1.26,5.22-.06.22-.11.52-.11.52-.71.07-1.91.02-2.77.02-.57-2.68-1.11-5.37-1.71-8.04-.56-2.46-1.2-4.9-1.78-7.36-.28-1.18-.49-2.37-.76-3.54-.04-.16-.22-.29-.33-.44.06-.19.12-.37.18-.56-.07,0-.15-.02-.22-.02.01.19.02.39.03.58-.02,2.62-.05,5.24-.06,7.85-.01,2.51-.01,5.02-.02,7.53,0,.07,0,.14,0,.22h0Z"
      />
      <path
        class="cls-7"
        d="m109.71,62.25c-.63.06-1.25.09-1.87.2-.87.15-1.13-.3-1.14-1.08,0-.13-.02-.27-.04-.55-.3.2-.54.32-.73.5-.86.8-1.82,1.41-2.97,1.59-.51.08-1.11.09-1.59-.1-1.95-.77-2.94-2.48-3.07-4.55-.12-1.91.11-3.74,1.6-5.04,1.15-1.01,2.45-1.85,3.74-2.67.79-.5,1.71-.81,2.75-1.29-.04-1.64,0-3.69-.27-5.28-.1-.62-.83-.64-1.55-.71-1.22-.12-1.81.09-2.11.93-.33.93-.63,1.68-1.14,2.87-.46.12-1.2.22-1.99.24-.45.01-.68-.1-.69-.62-.06-2.02,1.02-4.49,2.89-5.35,1.91-.88,3.98-.96,5.79.39,1.02.77,1.68,1.9,1.89,3.22.13.84.29,1.69.3,2.53.03,3.98,0,7.95.02,11.93,0,.93.12,1.86.19,2.83h0s0,0,0,0Zm-3.46-10.65c-.07-.05-.14-.1-.2-.15-.96.79-1.99,1.51-2.86,2.4-1.07,1.1-1.86,2.35-1.75,4.06.11,1.58.73,2.27,2.23,2.09,1.31-.16,2.56-1.6,2.57-2.95.01-1.56.04-3.13.05-4.69,0-.25-.03-.51-.04-.76h0s0,0,0,0Z"
      />
      <path
        class="cls-5"
        d="m166.1,62.54v-21.28h3.01c.06.33.12.66.19,1.1,1.09-1.07,2.24-1.57,3.65-1.57.97,0,1.84.27,2.49.89.8.76,1.56,1.59,1.56,2.92,0,5.21.1,10.41.16,15.62,0,.65,0,1.44,0,2.12-.96.01-2.22.05-3.12.07,0,0-.02-.39-.03-.61-.04-1.49-.03-2.98-.04-4.46,0-3.84,0-7.68-.03-11.53,0-.86-.06-1.81-1.01-2.16-.52-.19-1.19-.18-1.73-.03-1.39.39-2.03,1.35-2.04,2.79,0,5.06-.03,10.12-.02,15.18,0,.71,0,.96,0,.96-.68-.07-2.29-.02-3.06-.02h0s0,0,0,0Z"
      />
      <path
        class="cls-6"
        d="m224.42,67.71v-2.77c.81-.18,1.64-.35,2.46-.55.98-.24,1.33-.89,1.37-1.74.08-2.02-.62-3.86-1-5.77-.38-1.85-.83-3.69-1.28-5.53-.56-2.31-1.15-4.62-1.69-6.93-.24-1-.39-2.03-.58-3.07h3.4c.95,5.17,1.89,10.3,2.83,15.44.1,0,.2.02.3.03.93-5.15,1.86-10.29,2.8-15.47h3.41c-.37,1.84-.69,3.68-1.12,5.48-.89,3.75-1.86,7.48-2.75,11.23-.46,1.93-.78,3.89-1.25,5.82-.43,1.75-1.6,2.85-3.28,3.28-1.14.29-2.34.37-3.61.56h0Z"
      />
      <path
        class="cls-10"
        d="m199.03,46.62c-.93.22-1.7.33-2.41.6-.56.21-.6-.09-.73-.47-.27-.76-.52-1.55-.91-2.24-.65-1.14-1.62-1.41-2.66-.93-.92.42-1.48,1.65-1.16,2.7.17.57.41,1.19.81,1.6.88.92,1.89,1.72,2.83,2.58,1.58,1.44,3.36,2.77,4.04,4.91,1.11,3.52-.14,7.16-4.6,7.53-2.63.22-4.29-1.23-5.51-3.39-.33-.59-.51-1.26-.82-1.86-.31-.59-.16-.85.43-1.1,1.75-.74,1.76-.78,2.54.94.43.96.88,1.87,1.77,2.46.85.57,1.68.6,2.57.04.77-.49.93-1.19.96-2.03.06-1.72-1.02-2.8-2.06-3.87-.91-.94-1.94-1.77-2.9-2.67-1.14-1.07-2.23-2.16-2.87-3.67-.74-1.75-.47-3.35.5-4.89.9-1.44,2.25-1.95,3.86-1.87.47.02.95,0,1.43,0,1.51.02,2.62.87,3.37,2.05.66,1.05,1.01,2.32,1.53,3.59h0s0,0,0,0Z"
      />
      <path
        class="cls-8"
        d="m207.45,34.1c0,.5.02,1.01.02,1.51l-.03.02.03.02v1.37h0s0,.9,0,.9c0,.25,0,.51,0,.75v2.51h3.82v2.73c-1.24.08-2.49.15-3.84.23v1.01c-.02,5.49-.05,10.98-.03,16.47,0,.76,0,.99,0,.95-.66-.06-2.27-.01-3.09-.01v-18.46h-3.78v-2.93c.9,0,2.7,0,3.69,0,0,0,0-.16,0-.85-.04-2.08-.01-4.15-.01-6.44,1.07,0,2.17,0,3.18,0,.04,0,0,0,.03.19h0s0,0,0,0Z"
      />
      <path
        class="cls-9"
        d="m91.53,32.37h3.13v.82c0,7.71-.01,15.41-.03,23.12,0,1.36-.15,2.72-.77,3.95-.64,1.26-1.72,1.85-3.08,1.98-.99.09-3.66.31-3.72.31,0,0,.01-.23,0-.76.03-.59,0-1.19,0-1.94.84,0,1.65.02,2.46,0,.94-.04,1.77-.87,1.78-1.79.05-4.05.1-8.1.12-12.15.02-4.25,0-8.49,0-12.74,0-.26.07-.52.1-.79h0s0,0,0,0h0Z"
      />
      <path
        class="cls-3"
        d="m121.69,50.16c0-5.9,0-11.8-.01-17.7h0c.49-.03.98-.07,1.47-.08.55-.02,1.1,0,1.73,0,.01.27.04.53.04.79-.02,9.42-.04,18.83-.07,28.25,0,.29-.02.87-.02.87h-.01c-1.01.09-3.08.14-3.08.14,0-.11,0-.4,0-.51"
      />
      <path
        class="cls-4"
        d="m214.6,62.54v-21.18h3.08c.03.34.05.69.09,1.22.4-.32.67-.63,1-.77.85-.36,1.34-.28,1.89-.4.43-.02,1.34-.09,1.46.17,0,.85-.03,1.55-.33,2.5-.35.12-.7.16-1.12.16-2.23.02-2.94.75-2.95,3.06-.01,4.71-.02,9.41-.03,14.12,0,.65.02,1.13.02,1.13h-3.12Z"
      />
      <path
        class="cls-39"
        d="m181.64,41.24h3.1c.02.25.05.51.05.77-.01,6.49-.04,12.98-.02,19.47,0,.76,0,.92,0,.92-.68,0-2.36.02-3.13.02v-21.17h0Z"
      />
      <path
        class="cls-40"
        d="m117.15,41.24c0,1.52,0,2.92,0,4.32,0,5.32-.03,10.65-.02,15.97,0,.42-.02.88-.02.88-.68,0-2.3,0-3.09,0v-21.17h3.13,0Z"
      />
      <path
        class="cls-38"
        d="m161.96,44.96c0,.38,0,.77,0,1.14,0,2.65-.01,5.3-.02,7.95-.01,2.52-.05,5.03-.03,7.55,0,.65-.22.88-.83.85-.71-.03-1.42,0-2.23,0v-21.09c.95-.04,1.91-.09,2.88-.13h.24c0,.17,0,.34,0,.5h-.03s.03,0,.03,0c0,.41,0,.83,0,1.24,0,.09,0,.18,0,.27,0,.37,0,.73,0,1.09v.65h0Z"
      />
      <path
        class="cls-37"
        d="m113.84,33.4c1.01,0,2.36-.02,3.28.02,0,0,0,.29.02.46.04.97.02,1.94.02,2.91,0,.42-.02.62-.02.62-.71-.03-2.56.04-3.26-.03,0,0,0-.35-.01-.55-.05-1.1-.03-2.21-.03-3.43h0s0,0,0,0Z"
      />
      <path
        class="cls-27"
        d="m184.74,33.4c0,1.23-.02,2.36-.02,3.48,0,.12,0,.51,0,.51-.85,0-2.16.02-3.14.02,0-1.25-.02-2.42.02-3.6,0-.3,0-.4.01-.4.02,0,2.16,0,3.13,0h0Z"
      />
      <path
        class="cls-33"
        d="m161.92,33.44c.01.82.03,1.74.04,2.56.02.4.03,1.21.03,1.21-.86.02-2.38.03-3.25,0,0,0,0-.2-.01-.45-.05-1.06-.03-2.13-.03-3.19,1.03-.05,1.99-.09,2.95-.13,0,0,.25,0,.27,0h0Z"
      />
      <path class="cls-35" d="m161.94,54.06c0-2.65.01-5.3.02-7.95,0,2.65-.01,5.3-.02,7.95Z" />
      <path class="cls-36" d="m161.85,37.2c.04-.4.07-.81.11-1.21-.04.41-.07.81-.11,1.21Z" />
      <path
        class="cls-28"
        d="m139.03,43.02c-.01-.19-.02-.39-.03-.58.07,0,.15.02.22.02-.06.19-.12.37-.18.56h0s0,0,0,0Z"
      />
      <path class="cls-34" d="m138.95,58.63c0-.07,0-.15,0-.22,0,.07,0,.15,0,.22Z" />
      <path class="cls-30" d="m161.97,43.22c0-.09,0-.18,0-.27,0,.09,0,.18,0,.27Z" />
      <path class="cls-31" d="m161.88,41.26s-.1-.03-.14-.05c.05.02.1.03.14.05Z" />
      <polygon class="cls-29" points="124.73 62.29 124.74 62.29 124.78 62.31 124.73 62.29" />
      <path class="cls-32" d="m91.53,32.37h0s-.03,0-.05,0c.01,0,.03,0,.05,0Z" />
      <polygon class="cls-42" points="207.47 37.92 207.47 37.89 207.5 37.91 207.47 37.92" />
      <polygon class="cls-50" points="207.47 35.64 207.45 35.63 207.47 35.61 207.51 35.63 207.47 35.64" />
      <polygon class="cls-43" points="121.62 55.86 121.62 55.84 121.57 55.84 121.62 55.86" />
      <polygon class="cls-41" points="161.97 41.72 161.93 41.72 161.97 41.72 161.97 41.72" />
      <polygon class="cls-51" points="207.45 34.1 207.45 34.11 207.48 34.09 207.45 34.1" />
    </g>
  </g>
  <g id="logo">
    <g>
      <path
        class="cls-52"
        d="m63,40.95c-.49-.8-.95-1.63-1.48-2.41-1.39-2.05-3.02-3.88-4.89-5.51-1.59-1.39-3.31-2.57-5.21-3.49-1.26-.61-2.57-1.15-3.89-1.65-.75-.28-1.56-.4-2.34-.6h0c-.1-.02-.2-.05-.3-.08.1.03.2.05.3.08.03.04.05.1.09.11.38.14.75.27,1.13.41,2.21.79,4.26,1.91,6.19,3.24,1.76,1.22,3.35,2.63,4.78,4.24,1.22,1.39,2.27,2.89,3.07,4.55.44.92.78,1.89,1.17,2.84,0,.07.02.13.03.2.02.06.03.13.05.19.02.03.05.06.07.08.06.06.11.12.15.18-.04-.06-.09-.12-.15-.18,0,.23,0,.46,0,.7.02,0,.04-.01.06-.02-.02,0-.04.02-.06.02h0s-.09.1-.13.14h0s-.05.05-.08.06c-.04,0-.09,0-.13,0-.02.01-.04.01-.07.01h0c-.11.02-.23.04-.34.06-.02,0-.04.02-.06.03.02-.01.04-.02.06-.03-.01-.02-.02-.04-.04-.06-.06,0-.12,0-.18-.01-.02,0-.05,0-.07,0-.21-.04-.42-.08-.63-.12-.06-.03-.12-.06-.18-.09h0c-.33-.17-.65-.34-.98-.5-.06-.03-.12-.03-.18-.04.02.06.02.14.06.19.17.2.35.4.52.59.61.49,1.2,1,1.84,1.46.68.49,1.16,1.11,1.5,1.85.02.05.03.1.05.15.23.51.47,1.01.7,1.52.03.07.06.13.08.2.16.26.31.51.47.77.01.02.02.04.02.06.27.34.54.68.81,1.03.48-.67.97-1.33,1.42-2.02.07-.11,0-.35-.07-.5-.15-.3-.35-.57-.52-.85h.02s-.04-.05-.06-.07c-.01-.01-.02-.02-.01-.04-.01-.03-.03-.06-.04-.09-.02-.01-.03-.03-.03-.05-.02-.03-.03-.07-.05-.1,0-.02-.01-.05-.02-.07-.27-.81-.54-1.61-.81-2.42-.09-.26-.16-.52-.24-.78-.02-.07-.03-.14-.05-.21,0-.02-.01-.04-.03-.06-.02-.02-.03-.05-.05-.07h0c-.09-.23-.19-.47-.28-.71,0-.02-.01-.04-.02-.05-.02-.07-.03-.14-.05-.21-.01-.02-.02-.04-.03-.07-.01-.02-.03-.04-.04-.06-.16-.37-.31-.74-.47-1.11h-.01c-.02-.05-.03-.09-.05-.13,0-.02-.02-.05-.02-.07-.02-.02-.03-.05-.05-.07,0-.02-.02-.05-.02-.07-.02-.03-.04-.05-.06-.08-.05-.05-.1-.09-.14-.14,0-.02,0-.04,0-.06h0Zm-3.57,2.89s.07-.03.12-.02c-.04,0-.08,0-.12.02Zm3.48-1.97h0s.01.02.02.02c0,0-.01-.02-.02-.02Zm.32,1.04s0,0,0,.01c0,0,0-.01,0-.01,0,0-.02.02-.03.02.01,0,.02-.02.03-.02Z"
      />
      <path class="cls-54" d="m44.64,27.16h0s-.02,0-.03,0c0,0,.02,0,.02,0Z" />
      <path class="cls-56" d="m44.16,27.1c.15.02.31.03.46.05-.15-.05-.29-.09-.44-.14,0,.03-.01.06-.02.1Z" />
      <path class="cls-55" d="m44.64,27.16c.08.02.17.04.25.06-.08-.02-.16-.04-.25-.07h0s0,0,0,0Z" />
      <path
        class="cls-53"
        d="m35.22,83.03s.05-.06.08-.08c.13-.23.26-.47.4-.7h0c.07-.16.14-.32.21-.48,0-.02,0-.04.01-.06.02-.03.05-.05.07-.08h-.02c.07-.23.15-.46.22-.69,0-.05.02-.1.03-.15.01-.03.03-.05.04-.08,0-.06,0-.12.01-.19.04-.32.09-.65.14-.97,0-.25,0-.51,0-.76-.04-.17-.09-.34-.11-.5-.07-.6-.07-.61-.65-.54-1.04.12-1.73.73-2.22,1.61,0,.04,0,.09,0,.13-.01,1.42-1.22,3.1-2.56,3.54-.32.11-.66.18-.98.26-.02,0-.05,0-.07,0-.21.03-.42.05-.62.08h-.14c-.78.04-1.47-.27-2.16-.56-.3-.13-.6-.26-.9-.4-.02-.04-.04-.08-.06-.13-.02-.03-.03-.06-.05-.09,0-.02-.01-.05-.02-.07-.02-.03-.04-.05-.06-.08h0c-.21-.11-.42-.23-.63-.34h-.03s-.03,0-.03,0h-.1s-.03,0-.03,0c-.22,0-.48.09-.67.02-.71-.3-1.41-.64-2.1-.99-.14-.07-.25-.22-.37-.34-.02,0-.04-.01-.06-.03-.02-.02-.05-.04-.07-.06h0c-.75-.72-1.18-1.59-1.25-2.63-.01-.02-.01-.04-.01-.06h0c0-.24,0-.49,0-.73,0-.06,0-.12.01-.17.11-.42.22-.85.32-1.27,0-.02,0-.03.01-.05.3-.53.61-1.06.91-1.59,0-.28,0-.55,0-.83-.23-.48-.45-.97-.69-1.45-.14-.28-.33-.24-.56-.08-.9.66-1.63,1.46-2.15,2.44-1.12,2.11-1.12,4.25-.16,6.42.04.09.07.19.1.29h0s.04.05.06.07h0c.42.56.81,1.13,1.27,1.65.76.87,1.76,1.38,2.82,1.8.28.11.57.19.82.33.13.07.2.24.3.36h0c.04.05.08.11.12.16.35.26.71.31,1.16.25.28-.04.59.18.9.28.93.29,1.87.57,2.8.86.42,0,.83,0,1.25,0,.02-.01.04-.01.07,0,.73-.2,1.49-.32,2.18-.6,1.36-.55,2.42-1.48,3.23-2.7h0Z"
      />
      <path
        class="cls-47"
        d="m47.84,71.18c-.57-.19-.96-.03-1.2.5-.04.08-.12.17-.21.21-.49.21-.98.39-1.47.6-.08.03-.14.11-.21.17.06.06.11.14.18.19.73.55,1.46,1.09,2.2,1.62.11.08.27.07.4.11.15.04.29.08.43.12.02,0,.05,0,.07,0,.11,0,.23,0,.34,0,.37-.36.73-.73,1.1-1.09h0v-.84s0-.05,0-.07c.1-.61.21-1.22.31-1.83.02-.1.02-.19.02-.29-.11.01-.23,0-.33.04-.45.18-.89.38-1.34.55-.1.04-.23.05-.33.02Z"
      />
      <path
        class="cls-45"
        d="m16.09,78.37v-.14s-.01-.04,0-.07c-.02-.23-.04-.47-.06-.7v-.56c.06-.36-.13-.57-.36-.82-.39-.43-.7-.92-1.05-1.39-.02-.02-.03-.04-.04-.07-.02-.02-.03-.05-.05-.07-.02-.01-.02-.03-.02-.05-.02-.03-.04-.06-.06-.09-.01-.01-.01-.02,0-.03-.02-.04-.05-.07-.07-.11h0c-.36-.82-.61-1.66-.63-2.56,0-.02,0-.04,0-.07h0c0-.47,0-.95,0-1.42,0-.06,0-.12,0-.17,0-.02,0-.05,0-.07.04-.36.1-.73.11-1.09,0-.1-.1-.28-.19-.3-.74-.15-1.48-.29-2.23-.4-.09-.01-.28.12-.3.21-.12.55-.2,1.1-.29,1.65,0,.04-.01.09-.02.13,0,.62.01,1.25.02,1.87,0,.02,0,.05,0,.07.01.02.01.04,0,.06h0c.02.15.04.29.05.43,0,.05,0,.09,0,.14.02.08.05.15.07.23.18.92-.07,1.21-1.03,1.24-.19,0-.38,0-.57,0h0s-.03.01-.03.01h-.03s-1.79-.23-1.79-.23c-.02.03-.03.06-.04.1.61.38,1.23.76,1.84,1.15.02,0,.04,0,.06.02,1.3.4,2.61.8,3.5,1.94.03.03.04.08.06.12.01.03.03.05.04.08,0,.02.01.03.01.05.02,0,.04.02.06.03.32.37.65.73.97,1.1.03.04.06.08.1.13.18.14.36.28.53.42.54.29,1.07.59,1.61.88.05.03.12.03.18.04,0-.07,0-.15-.01-.22-.11-.49-.22-.97-.33-1.46h0Z"
      />
      <path class="cls-49" d="m23.69,67.93s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0h0Z" />
      <path
        class="cls-46"
        d="m43.85,86.8c-.71-.5-1.41-.99-2.12-1.49-.05-.05-.11-.09-.16-.14-.19-.3-.46-.4-.82-.36-.34.04-.69.02-1.03.02h0s-.04,0-.07,0c-.35-.14-.69-.28-1.04-.43h-.28s-.04.02-.06.02c-.6.54-1.33.42-2.03.38-.39-.02-.69.07-.89.41-.02.02-.04.03-.07.05-.02.02-.04.03-.05.05h0c-.71.51-1.43,1.01-2.14,1.52-.39.28.15.21.13.35.02,0,.05.01.07.02.03.02.05.03.08.05h0c.64.15,1.29.31,1.93.48.69,0,1.39,0,2.08,0h.07c.12.03.26.04.37.1.18.09.35.21.53.32.26-.08.51-.16.77-.25.16-.05.32-.11.48-.17.69,0,1.38,0,2.07,0,.73-.21,1.47-.43,2.2-.65.06-.02.1-.08.15-.12-.05-.05-.1-.11-.16-.16h0Z"
      />
      <path
        class="cls-44"
        d="m8.74,65.55c.7-.09,1.28.3,1.91.47.43.11.85.24,1.28.36.05,0,.09,0,.14.01l.76.14s.1,0,.14.01c.44.09.88.17,1.32.26h0s.05,0,.07.01c1.16.19,2.33.37,3.49.58.3.05.58.2.88.3.01.02.03.03.06.04.28.18.55.36.83.54,0,.02,0,.04,0,.06-.02.05-.03.09-.05.14,0,.02,0,.04,0,.07.26.5.68.7,1.24.64.11.13.23.27.34.4.05.05.1.1.15.16.04,0,.08,0,.13,0,.02.06.04.12.06.18.03.03.06.06.09.08l.27.27s.05,0,.07,0c0,0,0-.01.01-.02,0,0,0,.02-.01.02.04.05.08.09.13.14h0c.14.2.29.4.43.6.03.05.06.1.08.15.11.21.22.42.33.64l.21,1.94c-.01.14-.03.28-.04.42-.04.16-.07.32-.11.48-.02.07-.05.14-.07.21-.02.02-.03.05-.05.07-.19.35-.38.7-.57,1.06-.14.27-.28.54-.42.81,0,.3,0,.6,0,.9,0,.02,0,.05,0,.07.26.47.5.94.78,1.4.04.07.29.1.38.04,1.62-1.03,2.51-2.54,2.9-4.38.06-.27.11-.54.16-.81,0-.07,0-.13.01-.2-.12-.9-.25-1.8-.38-2.7-.02-.1-.1-.19-.15-.29h0s0,0,0,0c0-.02,0-.04-.02-.06,0,.02.01.04.02.06h0s-.01-.04-.02-.06c-.35-.62-.69-1.25-1.04-1.87-.03-.04-.06-.09-.09-.13-.22-.26-.44-.51-.67-.77-.02-.01-.03-.03-.03-.05-.02,0-.04-.01-.05-.03-.02-.02-.04-.04-.06-.06h0s-.04-.05-.06-.07h0s-.09-.09-.14-.14h0s-.05-.04-.08-.06h0s-.04-.05-.06-.07h0s-.05-.05-.07-.07h0s-.04-.05-.07-.07h0s-.05-.05-.07-.07h0s-.04-.05-.06-.07h0c-.14-.21-.35-.4-.41-.62-.13-.44-.56-.75-1.03-.66-.09.02-.21-.02-.28-.08-.91-.67-1.95-1.03-3.04-1.25-.63-.13-1.26-.25-1.89-.37h0s-.07-.04-.1-.07c-.06,0-.12,0-.18,0-.61-.09-1.23-.14-1.84-.26-1.07-.21-2.15-.4-3.19-.72-.6-.18-1.13-.58-1.69-.89h0s-.04-.05-.07-.07h0s-.05-.05-.07-.07c-.02-.02-.05-.05-.07-.07h0s-.05-.04-.07-.07h0c-.68-.63-.9-1.47-1.05-2.33-.05-.3-.04-.62-.06-.93v-.14c.09-.57.13-1.14.28-1.69.08-.32.11-.53-.14-.79-.47-.5-.9-1.04-1.35-1.56-.17-.2-.3-.37-.44.03-.17.46-.38.92-.61,1.35-.08.14-.31.29-.46.28-.28-.03-.58-.12-.8-.29-.51-.4-.98-.85-1.47-1.28-.11-.09-.23-.17-.34-.26.16.84.52,1.62,1.04,2.28.93,1.18,1.62,2.45,1.69,3.99,0,.1.04.2.06.3.3.92.64,1.81,1.26,2.57.27.33.11.67-.14.89-.37.32-.78.6-1.21.83-.41.22-.87.34-1.31.5-.23.08-.14.14,0,.21.07,0,.14,0,.21,0h1.52s.05,0,.07,0c.09,0,.17,0,.26-.01l2.24-.4c.16,0,.32,0,.49,0h0Zm15.9,4.44s0,0,0,0c0,.2,0,.31,0,.4v-.4h0Z"
      />
      <path class="cls-48" d="m2.58,54.4s-.03-.03-.04-.05c.01.02.02.03.03.05h0Z" />
      <path class="cls-18" d="m2.57,54.4s0,0,0,0c0,0,0,0,0-.01h0Z" />
      <path
        class="cls-17"
        d="m32.53,27.04c-.07.01-.13.03-.2.04,0,.02,0,.03,0,.05.07-.01.13-.02.2-.04,0-.02,0-.04-.01-.05Z"
      />
      <path
        class="cls-20"
        d="m29.73,77.05c-.27.7-.53,1.4-.8,2.1-.04.11-.06.22-.09.33v.07s-.01.1-.02.14c-.02.08-.03.16-.05.23,0,.31,0,.62,0,.94,0,.02.01.04,0,.07.05.24.12.47.13.71.02.26.15.31.36.28.32-.05.63-.11.95-.16h0s.05-.03.08-.05l.07-.02c.67-.39,1.24-.87,1.45-1.66,0-.05,0-.09.01-.14.06-.87.4-1.61,1.03-2.22h0s.05-.06.07-.09c0-.02,0-.04.03-.06,0-.02.02-.03.03-.03.02-.01.05-.02.07-.03,0-.02.01-.04.01-.06.02,0,.04,0,.07,0h0c.24-.2.47-.39.7-.59.13-.05.27-.1.4-.16.04,0,.07-.01.11-.02.03-.02.07-.05.1-.07h0s0-.04,0-.06c.46-.08.92-.15,1.37-.23h0c.6,0,1.19-.03,1.79-.03.07,0,.16.08.22.14.37.35.91.35,1.26,0,.06-.06.15-.14.22-.14.6,0,1.19.02,1.79.03,1.03.05,1.96.36,2.69,1.12.79.65,1.23,1.48,1.31,2.5,0,.02,0,.05,0,.07.18.83.76,1.32,1.45,1.73.02,0,.04.01.07.02.03.02.05.04.08.05h0c.28.05.56.1.84.15.31.06.48-.05.5-.38.02-.2.07-.4.11-.6,0-.34,0-.68,0-1.02-.02-.07-.03-.14-.05-.22,0-.07-.01-.15-.02-.22,0-.02-.01-.04,0-.06-.25-.72-.43-1.48-.76-2.16-.67-1.4-1.71-2.48-3.13-3.11-.81-.36-1.69-.55-2.54-.82-.02,0-.05,0-.07,0-.19,0-.37,0-.56,0h-1.52c-.21-.11-.42-.23-.63-.34h0s-.05-.04-.07-.06c-.25.02-.5.04-.75.06-.21.11-.42.22-.63.34h-.07c-.69,0-1.39,0-2.08,0-.68.19-1.4.31-2.05.58-1.53.63-2.72,1.68-3.51,3.16h0Zm2-1.91s-.01.02-.02.02c0,0,.02.01.02.02,0,0-.02-.01-.02-.02,0,0,.01-.02.02-.02Z"
      />
      <path
        class="cls-19"
        d="m20.57,34.08c2.18-2.16,4.65-3.93,7.43-5.23,1.3-.6,2.66-1.06,3.99-1.58.03-.01.05-.04.06-.1-3.89.84-7.44,2.42-10.63,4.82-.02,0-.05,0-.07.01-.74.66-1.5,1.29-2.22,1.97-1.33,1.28-2.56,2.65-3.6,4.18-.65.96-1.25,1.96-1.87,2.94,0,.02,0,.04-.02.06-.02.03-.04.05-.06.08,0,.02,0,.04-.02.06-.02.03-.03.05-.05.08,0,.02,0,.04-.02.06-.02.04-.04.08-.05.12h0s-.04.06-.06.08h0c-.1.19-.19.37-.29.56h0s0,.04-.01.06c-.04.12-.08.23-.12.35,0,.02-.01.05-.02.07-.04.09-.08.19-.12.28h0c-.02.07-.05.14-.07.2v.07c-.04.09-.07.18-.1.27h.02s-.05.05-.07.08c-.02.06-.04.12-.07.19-.01.03-.03.05-.04.08l-.03.07s-.03.09-.04.14c-.19.68-.36,1.37-.58,2.05-.15.47-.36.91-.54,1.36-.01.03-.02.05-.04.08-.21.36-.43.72-.62,1.09-.07.14-.14.37-.07.47.4.62.84,1.2,1.24,1.81.18.27.29.15.41-.02.37-.54.72-1.09,1.08-1.64,0-.03.02-.05.02-.08.02-.04.03-.08.05-.12h0s.03-.06.04-.08c.29-.65.57-1.31.89-1.95.4-.79,1.02-1.36,1.81-1.78.45-.24.8-.64,1.2-.96.08-.09.15-.19.23-.28.04-.04.08-.08.11-.12.02-.03.04-.07.06-.1h0s.04-.04.06-.07c.01-.02.02-.03.02-.05-.03-.06-.07-.12-.1-.17-.02,0-.03.01-.05.02-.05.02-.1.03-.14.05-.04.03-.09.06-.13.09-.16.07-.33.13-.49.2-.02,0-.04,0-.06.03-.01.05-.03.1-.04.14.02-.04.03-.08.04-.14-.1.03-.19.06-.29.1-.21.03-.41.06-.62.09-.06,0-.12,0-.19,0-.06,0-.11,0-.17,0h0s-.03,0-.03,0h-.03c-.11-.01-.22-.02-.33-.02-.45-.52-.06-1.02.08-1.48,1.01-3.29,2.85-6.09,5.29-8.5h0Zm-6.28,9.45h0s.02-.02.03-.04c0,.01-.02.02-.03.04Zm.11-.15s.04-.06.07-.1c-.03.03-.05.07-.07.1Z"
      />
      <path
        class="cls-23"
        d="m18.19,43.23s-.03-.03-.05-.04c-.14.1-.27.21-.41.31.03.06.07.12.1.17.12-.15.24-.29.36-.44h0Z"
      />
      <path
        class="cls-21"
        d="m30.91,72.01s-.05-.01-.07-.02c-.02-.02-.05-.04-.07-.06h0c-.25,0-.43-.05-.49-.35-.07-.3-.65-.58-.98-.44-.34.14-.6,0-.88-.11-.34-.14-.67-.3-1.01-.43-.09-.03-.19-.01-.29-.02,0,.09,0,.18.02.26.11.62.21,1.24.32,1.86,0,.02,0,.05,0,.07,0,.04,0,.09,0,.13,0,.24,0,.47,0,.71h0c.4.41.65.99,1.3,1.1.04,0,.09,0,.13,0,.09-.04.2-.15.27-.13.45.15.67-.17.97-.4.6-.47,1.25-.88,1.87-1.32.07-.05.13-.12.2-.18-.08-.06-.15-.14-.24-.18-.35-.17-.71-.32-1.06-.48h0Z"
      />
      <path class="cls-22" d="m75.95,43.85h0s0,0,0,0h0s0,0,0,0Z" />
      <path class="cls-25" d="m61.56,62.08s0,0,0,0h0,0s0,0,0,0Z" />
      <path class="cls-26" d="m.36,43.44s.02.02.03.03c0-.01-.02-.02-.03-.03h0s0,0,0,0Z" />
      <polygon class="cls-24" points=".34 43.43 .36 43.44 .36 43.44 .34 43.43" />
      <path
        class="cls-16"
        d="m0,32.64H0c.63.9,1.28,1.79,1.87,2.71.97,1.51,1.89,3.04,2.84,4.56,0,.02.01.04.02.07.02.02.04.05.07.07l.62,1.25s.05.09.07.14c.2.47.41.94.61,1.41,0,.04,0,.07.01.11.05.19.09.37.14.56,0,.03.02.05.02.08.01.07.03.14.04.21,0,.3.02.59,0,.89-.05.58-.45.92-1.03.9h-.03s-.03,0-.03,0h0c-.19,0-.38,0-.57,0-.09,0-.18,0-.27,0h-.07c-.78-.02-1.43-.41-2.09-.77-.39-.22-.74-.49-1.11-.74-.02-.02-.04-.04-.07-.07h0s-.07-.06-.07-.06c-.02-.01-.03-.02-.05-.02-.03-.02-.06-.04-.08-.06h0s-.05-.04-.07-.07h0s-.06-.09-.06-.09c-.03-.02-.05-.04-.08-.05-.07-.05-.14-.09-.21-.14H.43s-.03-.03-.04-.04c.01.01.03.03.04.04.05.09.1.18.14.27h0s.05.09.07.13h0c.04.05.08.11.12.16.44.61.86,1.23,1.31,1.83.19.26.41.48.62.72.01.02.02.04.03.06.02,0,.04,0,.05.02.02.02.04.04.06.06.02.02.05.05.07.07.03.05.05.09.08.14h0c1.55,1.05,2.84,2.32,3.68,4.07.47.99,1.22,1.85,1.89,2.74.85,1.14,1.81,2.2,2.6,3.38.71,1.05,1.23,2.21,1.25,3.52,0,.15,0,.31,0,.46v.36s.09.12.14.13c.78.15,1.56.29,2.34.42.1.02.28-.05.3-.12.4-1.16,1.24-2.03,1.98-2.96.29-.36.51-.76.76-1.15h0c.07-.17.15-.33.22-.5.03-.07.02-.15.03-.22-.07.03-.14.04-.2.09-.45.35-.88.72-1.34,1.06-.47.34-.98.54-1.58.36-.08-.03-.2-.08-.21-.14-.23-.74-.44-1.48-.65-2.23,0-.06,0-.12,0-.18.04-.6.02-1.22.14-1.81.22-1.04.29-2.07.11-3.19-.28.67-.49,1.32-.81,1.9-.22.39-.59.72-.93,1.02-.08.07-.42,0-.52-.11-.93-1.08-1.86-2.16-2.75-3.28-.58-.73-.86-1.59-.91-2.52,0-.13,0-.26-.01-.39,0-.24,0-.48,0-.72,0-.19.01-.38.02-.56.01-.05.03-.09.04-.14h0s0-.04,0-.06l.14-.97c.37-1,.72-2.01,1.12-3,.78-1.94,1.83-3.74,3.05-5.42.85-1.16,1.8-2.24,2.71-3.35.09-.09.19-.17.28-.26,1.08-.98,2.15-1.98,3.26-2.92.69-.58,1.46-1.07,2.19-1.61.3-.19.59-.38.89-.57h.01s.13-.07.13-.07h0s.05-.04.08-.07c.02-.01.05-.02.07-.03.02,0,.04-.02.05-.04h0c.08-.05.16-.09.24-.13.06-.03.12-.06.19-.1.05-.03.1-.07.15-.1.02-.01.04-.02.06-.03.04-.02.09-.04.13-.06h0c.34-.17.66-.37,1.01-.52.93-.42,1.86-.84,2.79-1.23.62-.26,1.26-.47,1.89-.71.98-.25,1.95-.54,2.93-.72,1.11-.21,2.24-.33,3.36-.49h.12c.49-.05.98-.09,1.47-.13.9,0,1.8,0,2.7,0h.07c.49.04.98.09,1.46.13.16,0,.32.01.48.02.3.04.6.08.9.13.12,0,.23.02.35.03.19.04.37.08.56.11.02,0,.05,0,.07,0,.21.04.43.09.64.13h.06s.05.01.07.01c.56.11,1.12.19,1.67.33.9.23,1.8.51,2.69.77,1.07.45,2.14.87,3.19,1.36,2.22,1.03,4.27,2.34,6.17,3.88.02.01.04.02.06.02,1.02.94,2.03,1.89,3.05,2.84.26.25.51.51.77.77.58.74,1.18,1.47,1.74,2.23,1.39,1.9,2.55,3.94,3.45,6.12.06.15.1.3.15.46,0,.02.02.04.02.06.47,1,.84,2.02.95,3.12.01.07.03.14.04.21,0,.19.01.38.02.56.02,0,.03,0,.05,0-.01.28-.03.56-.04.84,0,.09,0,.17-.01.26,0,.02,0,.04,0,.07-.03.87-.3,1.67-.83,2.34-.87,1.12-1.81,2.2-2.72,3.29-.31.37-.58.43-.91.06-.36-.39-.64-.87-.9-1.33-.18-.32-.26-.69-.39-1.03-.03-.08-.09-.15-.14-.23-.04.08-.08.15-.12.23,0,.05,0,.09,0,.14-.09,1.21.13,2.38.39,3.54.03.15.02.32.03.48,0,.19,0,.37,0,.55-.07.33-.1.67-.21,1-.12.38-.33.74-.44,1.12-.09.31-.3.42-.56.4-.31-.02-.66-.06-.92-.22-.69-.44-1.34-.94-1.99-1.41.09.23.2.5.31.77h0s.04.05.07.07h0c.46.65.92,1.3,1.39,1.94h0s.05.05.07.07h0c.61.59.98,1.32,1.19,2.14.8-.12,1.6-.23,2.39-.37.16-.03.29-.17.44-.27h0c0-.16,0-.31,0-.47,0-.07,0-.13,0-.2v-.07c.17-.72.26-1.48.53-2.16.73-1.85,2.05-3.31,3.34-4.78.8-.9,1.49-1.88,2-2.99.62-1.33,1.59-2.41,2.8-3.27.39-.28.73-.63,1.1-.94.62-.81,1.24-1.62,1.86-2.43.02-.02.04-.05.06-.07h0s.03-.05.05-.06c0-.02.02-.05.02-.07.02-.05.04-.09.06-.14h0c.03-.07.07-.14.11-.2-.08.05-.15.09-.23.14h0s-.05.04-.07.06h0s-.05.04-.08.06c-.02.02-.05.05-.07.07h0s-.12.08-.12.08h-.01s-.05.04-.07.06c-.81.61-1.67,1.13-2.65,1.44-.19.06-.4.06-.61.08-.3,0-.6,0-.9.01-.29-.1-.59-.19-.88-.29-.06-.32-.11-.64-.17-.96,0-.05,0-.09,0-.14.08-.97.4-1.86.83-2.72.02-.07.03-.14.06-.2,1.22-2.53,2.77-4.86,4.38-7.15.33-.47.68-.93,1.02-1.39-.13-.02-.2,0-.26.05-1.5,1.12-3.1,2.09-4.79,2.9-1.04.5-2.11.97-3.28,1.1-.68.07-1.37.1-1.95-.36-.49-.38-.7-.93-.83-1.51,0-.55,0-1.11-.01-1.66-.02.16-.05.31-.08.47.03-.16.05-.31.08-.47,0-.04,0-.09.01-.13.06-.23.12-.46.17-.7.01-.04.02-.08.03-.12.02-.05.03-.11.05-.16,0-.11.02-.21.03-.32.06-.15.12-.3.19-.44.01-.02.02-.03.02-.05.28-.74.56-1.49.84-2.23,0,0,0,0,0,0,.11-.21.22-.42.33-.64,0-.08-.01-.17-.02-.26,0,.09.01.17.02.26h0c.41-.76.83-1.52,1.28-2.36-.14.06-.19.08-.24.1-1.76.97-3.53,1.91-5.43,2.56-.94.32-1.87.56-2.87.45-.5-.25-.7-.67-.66-1.2.04-.52.12-1.04.18-1.57.36-1.34.72-2.67,1.08-4.01l.32-.99s.02-.08.03-.12c.02-.05.05-.09.07-.14,0-.02,0-.05,0-.07l.06-.2h0c.15-.42.31-.84.46-1.26.01-.04.02-.09.03-.13.02-.02.04-.05.06-.07h0c.02-.07.05-.14.07-.21.01-.05.02-.1.03-.15.01-.03.03-.06.04-.09,0-.01,0-.03,0-.04.04-.1.09-.2.13-.3,0-.02,0-.03,0-.05.09-.23.18-.47.27-.7h0c.14-.35.27-.71.41-1.06,0-.04.02-.08.03-.12.02-.02.04-.05.06-.07h-.01c.05-.11.1-.23.14-.35,0-.02,0-.04.01-.06.07-.17.13-.33.2-.5,0-.02.01-.04.02-.06.02-.03.03-.06.05-.09,0-.04.01-.08.02-.12.02-.04.03-.08.05-.12h0c.06-.15.13-.3.19-.44.03-.09.06-.17.09-.26.02-.02.04-.04.06-.07h0c-.08-.09.24-.33-.12-.32h0c-.08.1-.15.21-.23.32h0s-.04.05-.06.07h0c-.27.31-.55.61-.82.91h0s-.05.04-.07.07h0s-.05.05-.07.07h0s-.05.04-.08.07h0c-.12.13-.24.26-.36.4h0s-.04.05-.06.07h-.01s-.04.05-.06.07h0c-.07.07-.14.14-.2.21h0s-.04.06-.06.08h0c-.25.28-.5.56-.76.84h0s-.05.04-.07.07c-.02.02-.05.04-.07.06h0s-.04.05-.06.07h0s-.04.05-.06.08c-.02.02-.05.05-.07.07h0s-.05.04-.08.06h0s-.04.05-.07.08h0s-.05.04-.07.07h0s-.05.04-.08.07h.01s-.1.09-.15.14h0s-.83.83-.83.83h0s-.08.07-.08.07h0s-.05.04-.07.07c-.02.02-.05.05-.07.07h0s-.05.04-.07.07h0c-.1.09-.19.18-.28.27h0s-.04.05-.06.07c-.02.02-.05.04-.07.06h0s-.04.05-.06.07h0c-.28.26-.55.51-.83.76h0s-.04.05-.06.07h0s-.04.05-.06.08c-.02.02-.05.04-.07.06h0c-.18.17-.36.33-.55.5h0s-.05.04-.07.07h0s-.05.04-.07.07c-.02.02-.04.04-.07.06-.02.01-.04.02-.06.02-.23.19-.47.39-.7.58,0,.02,0,.03-.01.04l-.07.06c-.41.33-.83.67-1.24,1h0c-.35.19-.7.39-1.05.56-.12.06-.26.08-.39.12-.36.23-.87.17-1.15-.15-.49-.55-.76-1.21-.89-1.93h0s-.04-.09-.06-.14c0-.04,0-.09,0-.13-.02-.05-.03-.09-.05-.14,0-.04-.02-.09-.02-.13-.02-.12-.05-.24-.07-.36,0-.01,0-.03,0-.04-.02-.06-.04-.11-.06-.17,0-.04,0-.08,0-.12-.02-.12-.05-.24-.07-.36,0-.04,0-.09,0-.13-.04-.28-.09-.56-.13-.84h0c-.04-.48-.08-.97-.13-1.46v-.14c0-.16,0-.32-.01-.48,0-.02,0-.03,0-.05-.02-.22-.04-.43-.07-.65,0-.05,0-.09,0-.14,0-.11,0-.21,0-.32-.02-.26-.04-.53-.07-.79,0-.05,0-.09,0-.14,0-.14,0-.28,0-.42,0-.05,0-.09,0-.14-.02-.13-.04-.25-.07-.38-.07.04-.14.08-.21.12,0,.02-.02.04-.03.06-.08.12-.16.25-.24.37,0,.02,0,.03-.02.04l-.33.5s-.02.04-.03.06c-.02.02-.03.04-.05.06-.02.02-.05.05-.07.07h0c-.26.36-.51.73-.77,1.1h0s-.05.09-.07.13h0c-.07.09-.14.18-.21.27h0s-.04.05-.06.07h0s-.04.05-.06.08h0s-.05.08-.08.12h0c-.13.15-.26.3-.4.44h0s-.05.04-.08.06h.01c-.02.05-.01.13-.05.16-.65.65-1.3,1.3-1.95,1.94-.04.03-.11.03-.16.05h0s-.05.05-.07.08c-.02.02-.04.04-.06.06-.48.37-.99.62-1.61.69-.58.07-.89-.23-1.11-.7-.02-.05-.05-.1-.07-.15-.02-.04-.05-.08-.07-.13,0-.02-.01-.04,0-.07-.08-.21-.17-.41-.25-.62,0-.04-.02-.09-.02-.13-.04-.12-.09-.24-.13-.36,0-.02-.01-.04-.01-.06-.16-.51-.32-1.02-.48-1.53,0-.04,0-.07,0-.11-.04-.17-.09-.34-.13-.51,0-.02,0-.03,0-.05-.02-.05-.04-.11-.06-.16h0c-.02-.1-.05-.19-.07-.28,0-.04,0-.08-.01-.12-.11-.47-.21-.93-.32-1.4,0-.05-.02-.1-.02-.15v-.11c-.02-.06-.04-.11-.06-.17h0c-.05-.26-.1-.51-.15-.76,0-.02,0-.03,0-.05-.06-.35-.13-.71-.19-1.06,0-.06-.01-.12-.02-.18-.02-.06-.04-.11-.06-.16,0-.04,0-.08,0-.11-.02-.05-.03-.11-.05-.16,0-.07,0-.14,0-.21-.03-.08-.05-.15-.08-.23-.06-.36-.12-.72-.18-1.07,0-.1-.02-.19-.03-.29-.03-.12-.05-.23-.08-.35,0-.01,0-.03,0-.04-.02-.06-.05-.11-.07-.17,0-.01,0-.03,0-.04-.02-.19-.05-.38-.07-.57h0s-.06-.35-.06-.35c0-.07,0-.14,0-.21-.03-.09-.05-.18-.08-.27h0c-.02-.14-.04-.28-.06-.43,0-.06,0-.13,0-.19-.02-.12-.04-.24-.07-.36,0-.02,0-.03,0-.05-.02-.12-.04-.24-.07-.36h0c-.04-.25-.08-.51-.13-.76,0-.05,0-.09-.01-.14,0-.04,0-.08,0-.12-.02-.12-.04-.25-.06-.37,0-.02,0-.03,0-.05-.02-.15-.04-.29-.07-.44h0c-.05-.33-.09-.65-.14-.98,0-.04,0-.08,0-.12-.02-.12-.04-.25-.06-.37,0-.02,0-.04,0-.05-.02-.14-.04-.29-.05-.43-.02-.12-.05-.23-.07-.35-.03-.23-.05-.46-.08-.69,0-.02,0-.04,0-.05-.02-.1-.03-.19-.05-.29h-.01c-.02-.19-.04-.37-.07-.55,0-.07,0-.14,0-.21,0-.06,0-.12,0-.19-.04.04-.08.09-.13.13,0,.09,0,.19-.01.28-.13,1-.27,2-.41,3.01-.19,1.38-.38,2.76-.6,4.14-.19,1.19-.42,2.38-.65,3.56-.34,1.77-.65,3.55-1.07,5.3-.29,1.2-.73,2.37-1.17,3.53-.27.71-.61.82-1.46.61-1.06-.26-1.83-1-2.56-1.75-1.34-1.38-2.45-2.93-3.44-4.57-.05-.08-.14-.13-.21-.2-.02.08-.05.17-.06.25-.05,1.21-.08,2.42-.16,3.63-.05.7-.18,1.39-.27,2.08-.03.3-.05.59-.08.89.24-.02.48-.04.72-.06-.24.02-.48.04-.72.06h.01s-.03.05-.05.07c0,.07-.01.14-.02.2-.02.12-.05.24-.07.36-.02.06-.05.12-.07.19-.03.12-.07.24-.11.35-.17.41-.32.84-.53,1.23-.31.57-.84.81-1.35.62-.37-.14-.76-.29-1.08-.52-1.07-.8-2.11-1.65-3.17-2.48-.77-.75-1.54-1.5-2.31-2.25-.03-.03-.04-.08-.05-.12-.64-.64-1.3-1.26-1.93-1.91-.75-.78-1.47-1.58-2.27-2.34.03.12.06.24.11.36.6,1.54,1.21,3.08,1.8,4.63.27.7.51,1.4.76,2.11h0c.07.21.14.42.21.63,0,.02.02.05.03.07.02.07.03.14.04.21,0,.02,0,.04.02.06.02.03.03.06.05.09.03.09.05.17.08.26.02.1.04.19.06.29,0,.02,0,.04.02.06.02.02.04.04.06.06h0s.05.06.07.09c-.02-.03-.05-.06-.07-.09.11.39.22.79.34,1.18,0,.05.01.09.02.14.02.05.03.1.05.15l.03.13c.03.12.07.24.1.35,0,.04.01.09.02.13l.04.21.03.14s.03.06.05.1c.05.24.09.49.14.73h0s-.01.05-.02.07c0,.09.01.19.02.28.02.03.04.06.06.09.01.04.02.09.03.13.01.12.03.24.04.35,0,.07.01.13.02.2,0,.27,0,.55,0,.82-.11.64-.47.93-1.12.91-.12,0-.23,0-.35,0-.7-.16-1.41-.27-2.08-.49-.86-.28-1.7-.66-2.55-1h0c-.32-.17-.64-.35-.97-.52-.6-.32-1.19-.64-1.79-.95-.06-.03-.14-.03-.21-.04.02.06.02.14.05.19.22.43.45.85.67,1.28.01.01.02.03.02.04.02.03.03.06.05.08.01.01.02.03.02.04.02.04.05.07.07.11.02.04.03.08.04.13.02.02.02.03.03.06.02.03.03.06.05.08.02.02.02.03.02.06.02.03.04.06.06.09.01.02.02.04.01.07.44,1.09.94,2.16,1.31,3.27.24.71.29,1.47.43,2.22,0,.16,0,.32,0,.48-.02.87-.26,1.65-1.05,2.11-.3.17-.69.18-1.04.26-.12,0-.23,0-.35,0-.13,0-.25,0-.38-.02-1.52-.2-2.9-.82-4.2-1.57-1.41-.81-2.76-1.72-4.14-2.59H.04s-.03-.01-.04-.02c0,.01.01.03.02.04,0,0,0,0,0,0H0Zm68.2,12.57s.02-.03.03-.04c0,.01-.02.03-.03.04,0,0-.02-.01-.03-.02.01,0,.02.01.03.02Zm-7.63-25.41c-.02.21,0,.43.15.64.21-.15.32-.05.31.13,0-.18-.1-.27-.32-.08,0,0,0-.01,0-.02,0,0,0-.02,0-.02,0,0-.01.01-.02.02-.12-.23-.15-.45-.13-.66h0Z"
      />
      <path class="cls-14" d="m38.46,0h0s0,0,.01,0C38.47,0,38.46,0,38.46,0Z" />
      <path
        class="cls-15"
        d="m73.61,54.95s-.05.04-.08.06h0c-.54.41-1.06.85-1.64,1.2-.36.22-.64.03-.79-.36-.11-.3-.23-.6-.34-.9h0s-.04-.05-.06-.07h0s-.04-.09-.06-.14h0c-.32-.41-.32-.41-.67.01-.12.14-.25.26-.38.39,0,.02-.02.02-.04.03-.26.33-.51.67-.8.97-.22.23-.22.43-.15.73.14.55.2,1.12.29,1.68,0,.12,0,.23,0,.35v.07c-.05,1.13-.28,2.2-1.11,3.05h0s-.05.04-.07.07h0s-.05.05-.07.07h0s-.05.04-.07.06h0c-.61.57-1.37.91-2.16,1.09-1.38.32-2.77.56-4.16.83-1.19.24-2.4.42-3.57.74-.65.18-1.23.59-1.85.88-.14.06-.31.06-.46.08-.02,0-.04,0-.07,0-.02,0-.05,0-.07,0-.45.16-.79.4-.87.93-.03.19-.29.35-.44.52h0s-.05.04-.07.06h0s-.04.05-.06.07h0s-.05.04-.07.06h0s-.04.05-.06.08c-.02.02-.05.04-.07.06h0c-.04.05-.09.1-.13.14h0c-.31.34-.62.68-.93,1.02.02.02.03.04.04.06-.01-.02-.03-.04-.04-.06-.22.33-.44.66-.66.99h0c-.1.21-.2.41-.3.62h0c-.22.79-.44,1.58-.66,2.37h0s0,.04,0,.06c0,.32,0,.65,0,.97v.21c.2.99.41,1.96.91,2.85.54.94,1.21,1.76,2.14,2.34.2.12.33.11.43-.06.26-.48.51-.97.76-1.45,0-.3,0-.6,0-.9,0-.02,0-.05,0-.07-.25-.42-.52-.83-.76-1.26-.1-.17-.15-.36-.22-.54h0s-.04-.05-.05-.07c-.02-.07-.05-.14-.07-.21-.03-.16-.07-.32-.1-.48-.02-.16-.03-.31-.05-.47,0-.22,0-.44,0-.66h0s0-.04,0-.06c.05-1.07.52-1.95,1.26-2.7h0c.09-.09.18-.18.27-.27.03-.03.06-.06.09-.08.06-.06.13-.13.19-.19.05-.05.1-.1.15-.15.14-.27.34-.4.67-.42.24-.02.47-.23.71-.35h0s.1-.08.14-.12c.02-.07.05-.14.07-.21.06-.13.09-.31.19-.38.29-.21.61-.38.92-.57h0s.04,0,.06-.02c.3-.09.61-.18.91-.27h0c.83-.14,1.66-.29,2.48-.43.09,0,.18-.01.28-.02.63-.1,1.26-.21,1.88-.31.13-.02.27-.05.4-.07h.28c.83-.27,1.66-.52,2.5-.78h0c.28-.02.55-.05.83-.07.16,0,.32,0,.48,0,.02,0,.05,0,.07,0,.14,0,.28,0,.42,0-.12-.22-.26-.3-.42-.33.16.03.3.11.42.33.04,0,.09,0,.13,0l.41.11s.05.01.07.02c.23.05.47.09.7.14h.03s.03,0,.03,0c.09.04.19.09.28.13.02,0,.05,0,.07,0,.05,0,.09,0,.14,0,.53,0,1.06,0,1.59,0,.02,0,.05,0,.07,0,.05,0,.09,0,.14,0,.02,0,.04-.01.07,0-.03-.08-.05-.17-.08-.25-.6-.24-1.19-.47-1.79-.71-.03-.03-.07-.05-.1-.08-.03-.02-.07-.04-.1-.06-.03-.03-.07-.05-.1-.08-.04-.02-.07-.05-.11-.07h0s-.07-.09-.11-.13c-.47-.44-.47-.72-.13-1.23.27-.4.47-.85.71-1.27-.11-.02-.22-.05-.33-.07.11.02.22.05.33.07h0c.2-.76.45-1.5.58-2.26.16-.97.57-1.81,1.17-2.57.59-.75,1.07-1.57,1.35-2.49.03-.1.06-.21.11-.43-.28.26-.47.44-.65.62h0s0,0,0,0Z"
      />
      <path
        class="cls-12"
        d="m56.45,71.41c-.2-.15-.36-.17-.49.09-.24.49-.48.98-.72,1.47,0,.28,0,.56-.01.83.3.53.61,1.06.91,1.59.01.01.02.03,0,.04.11.42.22.85.33,1.27,0,.04,0,.07.01.11v.87h0c-.05,1.05-.51,1.91-1.25,2.64-.79.79-1.85,1.09-2.84,1.5-.08.03-.2-.03-.29-.06-.39-.13-.86.08-1.04.45-.05.1-.11.23-.2.26-.83.3-1.66.6-2.5.87-.17.06-.36.02-.55.03h-.07c-1-.01-1.9-.28-2.66-.96-.02,0-.03-.01-.04-.03-.9-.67-1.35-1.59-1.5-2.68-.01-.07-.02-.14-.03-.21v-.07c-.51-1.08-1.36-1.67-2.56-1.69-.09,0-.24.13-.26.22-.08.27-.1.56-.15.84,0,.25,0,.51,0,.76.04.35.09.69.13,1.04,0,.04.01.08.02.12.09.26.18.52.27.78,0,.02,0,.04,0,.07.42.99.96,1.9,1.73,2.66,1.14,1.12,2.51,1.81,4.1,2.03.11.02.22.05.33.08.44,0,.88,0,1.31,0,.68-.18,1.36-.36,2.04-.55.15-.04.3-.1.44-.17.62-.31,1.25-.51,1.95-.36.04-.01.09-.02.14-.03.57-1.01,1.72-1.1,2.61-1.59,1.21-.67,2.2-1.55,2.86-2.79.04-.07.1-.12.16-.18h0s.04-.05.06-.08h0c.42-1,.78-2.02.79-3.12.02-2.53-1-4.55-3.03-6.06h0Z"
      />
      <path
        class="cls-13"
        d="m69.03,74s-.05,0-.07,0c-.19.04-.37.09-.55.13-.02,0-.05,0-.07,0-.09,0-.19,0-.28,0h-.03s-.03.01-.03.01c-.19.02-.37.04-.56.06-.04,0-.08,0-.11,0-.13,0-.25,0-.38,0h0s-.03.01-.03.01h-.03c-.2-.04-.41-.04-.61-.09-.43-.12-.59-.41-.5-.85.07-.36.13-.72.19-1.08,0-.02,0-.04,0-.07,0-.58,0-1.16,0-1.73,0-.12,0-.23,0-.35-.1-.55-.18-1.11-.3-1.66-.02-.09-.2-.22-.29-.21-.77.12-1.54.26-2.3.41-.06.01-.14.17-.13.26.03.35.08.7.12,1.05,0,.05,0,.09,0,.14v1.88h0c-.09,1.61-.71,2.99-1.8,4.17-.23.25-.41.47-.36.82v.62c-.11.7-.21,1.4-.32,2.1-.02.13-.04.25-.06.38.13-.04.26-.08.38-.13.11-.05.22-.12.33-.18.03,0,.05-.01.08-.02,1.12-.74,2-1.73,2.84-2.77.31-.38.82-.6,1.24-.9.02,0,.04-.02.06-.03.51-.2,1.03-.37,1.52-.61.8-.39,1.58-.83,2.36-1.25l-.06-.14h-.29,0Z"
      />
      <path class="cls-11" d="m17.4,27.78v.28c0,.09.02.18.02.27,0-.27,0-.55,0-.82,0,.09-.01.18-.02.27h0Z" />
    </g>
  </g>
</svg>`
//crown logo only
export const circleLogo = html`<svg
  id="Layer_1"
  data-name="Layer 1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  viewBox="0 0 904.68 1038.66"
>
  <defs>
    <style>
      .cls-1 {
        fill: url(#linear-gradient);
      }

      .cls-2 {
        fill: url(#linear-gradient-8);
      }

      .cls-3 {
        fill: url(#linear-gradient-9);
      }

      .cls-4 {
        fill: url(#linear-gradient-3);
      }

      .cls-5 {
        fill: url(#linear-gradient-4);
      }

      .cls-6 {
        fill: url(#linear-gradient-2);
      }

      .cls-7 {
        fill: url(#linear-gradient-6);
      }

      .cls-8 {
        fill: url(#linear-gradient-7);
      }

      .cls-9 {
        fill: url(#linear-gradient-5);
      }

      .cls-10 {
        fill: url(#linear-gradient-14);
      }

      .cls-11 {
        fill: url(#linear-gradient-18);
      }

      .cls-12 {
        fill: url(#linear-gradient-22);
      }

      .cls-13 {
        fill: url(#linear-gradient-20);
      }

      .cls-14 {
        fill: url(#linear-gradient-21);
      }

      .cls-15 {
        fill: url(#linear-gradient-23);
      }

      .cls-16 {
        fill: url(#linear-gradient-15);
      }

      .cls-17 {
        fill: url(#linear-gradient-19);
      }

      .cls-18 {
        fill: url(#linear-gradient-16);
      }

      .cls-19 {
        fill: url(#linear-gradient-17);
      }

      .cls-20 {
        fill: url(#linear-gradient-13);
      }

      .cls-21 {
        fill: url(#linear-gradient-12);
      }

      .cls-22 {
        fill: url(#linear-gradient-10);
      }

      .cls-23 {
        fill: url(#linear-gradient-11);
      }

      .cls-24 {
        fill: url(#linear-gradient-27);
      }

      .cls-25 {
        fill: url(#linear-gradient-24);
      }

      .cls-26 {
        fill: url(#linear-gradient-26);
      }

      .cls-27 {
        fill: url(#linear-gradient-25);
      }
    </style>
    <linearGradient
      id="linear-gradient"
      x1="654.79"
      y1="729.35"
      x2="654.79"
      y2="448.38"
      gradientTransform="translate(0 1050.06) scale(1 -1)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#e2a72b" />
      <stop offset="1" stop-color="#c3702a" />
    </linearGradient>
    <linearGradient
      id="linear-gradient-2"
      x1="525.92"
      y1="730.16"
      x2="525.92"
      y2="730.07"
      gradientTransform="translate(0 1050.06) scale(1 -1)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#e2a72b" />
      <stop offset="1" stop-color="#c3702a" />
    </linearGradient>
    <linearGradient
      id="linear-gradient-3"
      x1="523.05"
      y1="731.83"
      x2="523.05"
      y2="730.16"
      gradientTransform="translate(0 1050.06) scale(1 -1)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#e2a72b" />
      <stop offset="1" stop-color="#c3702a" />
    </linearGradient>
    <linearGradient
      id="linear-gradient-4"
      x1="527.51"
      y1="730.13"
      x2="527.51"
      y2="729.34"
      gradientTransform="translate(0 1050.06) scale(1 -1)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#e2a72b" />
      <stop offset="1" stop-color="#c3702a" />
    </linearGradient>
    <linearGradient
      id="linear-gradient-5"
      x1="317.23"
      y1="209.75"
      x2="317.23"
      y2="33.08"
      gradientTransform="translate(0 1050.06) scale(1 -1)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#e2a72b" />
      <stop offset="1" stop-color="#c3702a" />
    </linearGradient>
    <linearGradient
      id="linear-gradient-6"
      x1="557.2"
      y1="218.55"
      x2="557.2"
      y2="169.99"
      gradientTransform="translate(0 1050.06) scale(1 -1)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#e2a72b" />
      <stop offset="1" stop-color="#c3702a" />
    </linearGradient>
    <linearGradient
      id="linear-gradient-7"
      x1="140.76"
      y1="246.52"
      x2="140.76"
      y2="107.09"
      gradientTransform="translate(0 1050.06) scale(1 -1)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#e2a72b" />
      <stop offset="1" stop-color="#c3702a" />
    </linearGradient>
    <linearGradient
      id="linear-gradient-8"
      x1="279.18"
      y1="249.67"
      x2="279.18"
      y2="249.61"
      gradientTransform="translate(0 1050.06) scale(1 -1)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#e2a72b" />
      <stop offset="1" stop-color="#c3702a" />
    </linearGradient>
    <linearGradient
      id="linear-gradient-9"
      x1="453.32"
      y1="55.51"
      x2="453.32"
      y2="11.52"
      gradientTransform="translate(0 1050.06) scale(1 -1)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#e2a72b" />
      <stop offset="1" stop-color="#c3702a" />
    </linearGradient>
    <linearGradient
      id="linear-gradient-10"
      x1="168.8"
      y1="409.43"
      x2="168.8"
      y2="117.3"
      gradientTransform="translate(0 1050.06) scale(1 -1)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#e2a72b" />
      <stop offset="1" stop-color="#c3702a" />
    </linearGradient>
    <linearGradient
      id="linear-gradient-11"
      x1="30.13"
      y1="409.65"
      x2="30.13"
      y2="409.05"
      gradientTransform="translate(0 1050.06) scale(1 -1)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#e2a72b" />
      <stop offset="1" stop-color="#c3702a" />
    </linearGradient>
    <linearGradient
      id="linear-gradient-12"
      x1="30.34"
      y1="409.1"
      x2="30.34"
      y2="408.97"
      gradientTransform="translate(0 1050.06) scale(1 -1)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#e2a72b" />
      <stop offset="1" stop-color="#c3702a" />
    </linearGradient>
    <linearGradient
      id="linear-gradient-13"
      x1="382.17"
      y1="731.41"
      x2="382.17"
      y2="730.34"
      gradientTransform="translate(0 1050.06) scale(1 -1)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#e2a72b" />
      <stop offset="1" stop-color="#c3702a" />
    </linearGradient>
    <linearGradient
      id="linear-gradient-14"
      x1="453.3"
      y1="190.82"
      x2="453.3"
      y2="84.86"
      gradientTransform="translate(0 1050.06) scale(1 -1)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#e2a72b" />
      <stop offset="1" stop-color="#c3702a" />
    </linearGradient>
    <linearGradient
      id="linear-gradient-15"
      x1="251.01"
      y1="729.86"
      x2="251.01"
      y2="448.87"
      gradientTransform="translate(0 1050.06) scale(1 -1)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#e2a72b" />
      <stop offset="1" stop-color="#c3702a" />
    </linearGradient>
    <linearGradient
      id="linear-gradient-16"
      x1="211.62"
      y1="541.19"
      x2="211.62"
      y2="535.5"
      gradientTransform="translate(0 1050.06) scale(1 -1)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#e2a72b" />
      <stop offset="1" stop-color="#c3702a" />
    </linearGradient>
    <linearGradient
      id="linear-gradient-17"
      x1="349.58"
      y1="218.56"
      x2="349.58"
      y2="170"
      gradientTransform="translate(0 1050.06) scale(1 -1)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#e2a72b" />
      <stop offset="1" stop-color="#c3702a" />
    </linearGradient>
    <linearGradient
      id="linear-gradient-18"
      x1="894.99"
      y1="533.37"
      x2="894.99"
      y2="533.31"
      gradientTransform="translate(0 1050.06) scale(1 -1)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#e2a72b" />
      <stop offset="1" stop-color="#c3702a" />
    </linearGradient>
    <linearGradient
      id="linear-gradient-19"
      x1="725.35"
      y1="318.62"
      x2="725.35"
      y2="318.55"
      gradientTransform="translate(0 1050.06) scale(1 -1)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#e2a72b" />
      <stop offset="1" stop-color="#c3702a" />
    </linearGradient>
    <linearGradient
      id="linear-gradient-20"
      x1="4.38"
      y1="538.16"
      x2="4.38"
      y2="537.82"
      gradientTransform="translate(0 1050.06) scale(1 -1)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#e2a72b" />
      <stop offset="1" stop-color="#c3702a" />
    </linearGradient>
    <linearGradient
      id="linear-gradient-21"
      x1="4.12"
      y1="538.35"
      x2="4.12"
      y2="538.14"
      gradientTransform="translate(0 1050.06) scale(1 -1)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#e2a72b" />
      <stop offset="1" stop-color="#c3702a" />
    </linearGradient>
    <linearGradient
      id="linear-gradient-22"
      x1="452.34"
      y1="1049.92"
      x2="452.34"
      y2="320.33"
      gradientTransform="translate(0 1050.06) scale(1 -1)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#e2a72b" />
      <stop offset="1" stop-color="#c3702a" />
    </linearGradient>
    <linearGradient
      id="linear-gradient-23"
      x1="453.3"
      y1="1050.06"
      x2="453.3"
      y2="1049.91"
      gradientTransform="translate(0 1050.06) scale(1 -1)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#e2a72b" />
      <stop offset="1" stop-color="#c3702a" />
    </linearGradient>
    <linearGradient
      id="linear-gradient-24"
      x1="737.25"
      y1="409.83"
      x2="737.25"
      y2="116.61"
      gradientTransform="translate(0 1050.06) scale(1 -1)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#e2a72b" />
      <stop offset="1" stop-color="#c3702a" />
    </linearGradient>
    <linearGradient
      id="linear-gradient-25"
      x1="589.4"
      y1="209.93"
      x2="589.4"
      y2="33.1"
      gradientTransform="translate(0 1050.06) scale(1 -1)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#e2a72b" />
      <stop offset="1" stop-color="#c3702a" />
    </linearGradient>
    <linearGradient
      id="linear-gradient-26"
      x1="765.48"
      y1="246.54"
      x2="765.48"
      y2="107.49"
      gradientTransform="translate(0 1050.06) scale(1 -1)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#e2a72b" />
      <stop offset="1" stop-color="#c3702a" />
    </linearGradient>
    <linearGradient
      id="linear-gradient-27"
      x1="205.12"
      y1="725.92"
      x2="205.12"
      y2="716.27"
      gradientTransform="translate(0 1050.06) scale(1 -1)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#e2a72b" />
      <stop offset="1" stop-color="#c3702a" />
    </linearGradient>
  </defs>
  <path
    class="cls-1"
    d="m742.34,482.51c-5.78-9.47-11.19-19.2-17.42-28.36-16.4-24.1-35.61-45.71-57.61-64.94-18.74-16.38-39.05-30.34-61.37-41.15-14.9-7.22-30.28-13.58-45.79-19.4-8.84-3.32-18.37-4.77-27.6-7.06h0c-1.19-.29-2.39-.59-3.58-.89,1.17.32,2.35.64,3.52.95.34.46.58,1.18,1.03,1.35,4.42,1.65,8.87,3.21,13.31,4.79,26.1,9.31,50.24,22.45,72.93,38.2,20.74,14.39,39.53,30.99,56.28,50.01,14.41,16.37,26.79,34,36.13,53.64,5.17,10.87,9.21,22.28,13.76,33.45.11.78.22,1.56.34,2.34.2.74.4,1.48.6,2.21.27.33.54.66.81.99.74.73,1.35,1.42,1.81,2.09-.47-.66-1.07-1.36-1.81-2.09.02,2.73.04,5.46.06,8.19.25-.08.47-.16.69-.26-.21.09-.44.18-.69.26l-.02.05c-.52.53-1.04,1.07-1.56,1.6l-.09.09c-.31.22-.62.45-.92.67-.52-.03-1.03-.06-1.55-.08-.25.12-.52.17-.79.15l.03-.02c-1.33.24-2.66.48-3.99.71-.25.1-.5.21-.75.32.25-.12.5-.23.75-.32-.15-.22-.29-.43-.44-.65-.72-.05-1.44-.11-2.15-.16-.27-.01-.54-.02-.81-.03-2.47-.46-4.93-.93-7.4-1.39-.71-.35-1.43-.7-2.14-1.05h0c-3.86-1.96-7.7-3.95-11.58-5.87-.65-.32-1.44-.36-2.17-.53.22.74.23,1.64.68,2.18,1.99,2.39,4.1,4.67,6.17,6.99,7.19,5.74,14.17,11.79,21.64,17.15,7.97,5.72,13.67,13.03,17.7,21.82.21.58.41,1.16.62,1.74,2.74,5.96,5.49,11.91,8.23,17.87.33.79.66,1.58,1,2.37,1.85,3.02,3.7,6.04,5.55,9.06.16.23.23.49.22.76,3.18,4.04,6.36,8.07,9.54,12.11,5.64-7.9,11.43-15.7,16.75-23.8.83-1.27.03-4.16-.84-5.89-1.76-3.49-4.08-6.69-6.18-10.01l.18-.06c-.22-.27-.45-.54-.67-.81-.15-.12-.21-.28-.16-.48-.16-.35-.33-.69-.49-1.03-.19-.15-.3-.35-.34-.59-.21-.39-.41-.77-.62-1.16-.09-.27-.17-.55-.26-.82-3.18-9.5-6.38-18.99-9.53-28.5-1.01-3.05-1.88-6.15-2.81-9.23-.19-.84-.39-1.68-.58-2.52-.02-.28-.12-.52-.3-.74-.19-.27-.38-.55-.56-.82l.1.05c-1.11-2.8-2.21-5.6-3.32-8.4-.02-.24-.12-.45-.28-.64-.18-.84-.36-1.68-.55-2.52-.12-.26-.25-.51-.37-.77-.16-.24-.33-.47-.49-.71-1.84-4.36-3.69-8.72-5.53-13.08l-.14-.14c-.21-.45-.41-.9-.62-1.36-.09-.27-.18-.54-.28-.81-.19-.28-.38-.55-.56-.83-.09-.28-.18-.55-.27-.83-.23-.32-.47-.64-.7-.97-.56-.55-1.12-1.09-1.67-1.64.05-.26.02-.51-.09-.75h.01Zm-42.02,34.02c.41-.23.88-.3,1.39-.28-.51-.02-.98.05-1.39.28Zm40.99-23.22h0c.07.1.15.19.23.29-.08-.1-.16-.19-.23-.29Zm3.78,12.21c.02.06.06.11.09.17-.03-.06-.06-.12-.09-.17-.11.1-.24.19-.36.29.12-.1.24-.19.36-.29Z"
  />
  <path class="cls-6" d="m526.03,319.99l.05-.06c-.11-.01-.21-.02-.32-.03.09.03.18.06.27.09Z" />
  <path class="cls-4" d="m520.34,319.37c1.81.18,3.62.36,5.42.54-1.73-.56-3.46-1.11-5.18-1.67-.08.38-.16.76-.24,1.13Z" />
  <path class="cls-5" d="m526.04,319.99c.98.24,1.96.49,2.94.73-.96-.26-1.93-.52-2.89-.78l-.05.06h0Z" />
  <path
    class="cls-9"
    d="m414.99,978.37c.3-.32.59-.65.89-.97,1.56-2.76,3.12-5.51,4.68-8.27l-.03.03c.81-1.9,1.63-3.8,2.44-5.7-.07-.27-.03-.52.13-.76.27-.31.54-.61.82-.92l-.23-.02c.88-2.71,1.76-5.42,2.64-8.14.11-.57.23-1.14.34-1.71.17-.31.34-.61.5-.92.04-.73.08-1.46.12-2.19.53-3.81,1.07-7.62,1.6-11.43,0-3,0-6-.01-8.99-.43-1.98-1.02-3.95-1.25-5.95-.82-7.1-.78-7.23-7.65-6.42-12.21,1.43-20.33,8.63-26.13,18.97-.03.52-.05,1.05-.08,1.57-.12,16.72-14.34,36.49-30.12,41.7-3.79,1.25-7.72,2.09-11.58,3.12-.27.02-.54.03-.82.05-2.45.3-4.9.61-7.35.91h-1.63c-9.18.48-17.3-3.13-25.44-6.61-3.56-1.52-7.1-3.11-10.65-4.67-.23-.5-.46-1-.69-1.49-.2-.36-.41-.71-.61-1.07-.07-.27-.13-.54-.2-.81-.23-.32-.46-.63-.69-.95l-.05-.05c-2.47-1.3-4.95-2.61-7.42-3.91l-.4.04-.39-.1h-.81l-.38.11h-.39c-2.63.11-5.64,1.11-7.84.18-8.41-3.53-16.6-7.6-24.77-11.68-1.7-.85-2.93-2.65-4.37-4.01-.26-.02-.49-.12-.69-.3-.27-.22-.55-.43-.82-.65l.03.05c-8.89-8.48-13.85-18.81-14.71-31.09-.13-.23-.17-.47-.12-.73h.1c0-2.87,0-5.76.02-8.64.05-.69.1-1.37.15-2.06,1.27-4.99,2.55-9.97,3.82-14.96-.07-.21-.03-.4.12-.56,3.58-6.26,7.16-12.52,10.74-18.78-.04-3.27-.08-6.53-.11-9.8-2.71-5.69-5.35-11.42-8.15-17.07-1.64-3.3-3.91-2.82-6.54-.91-10.57,7.72-19.17,17.15-25.31,28.74-13.18,24.87-13.14,50.09-1.92,75.6.49,1.1.82,2.27,1.23,3.41l-.09-.02c.25.3.5.6.74.9l.03.04c4.96,6.51,9.6,13.29,14.96,19.45,8.92,10.26,20.75,16.27,33.18,21.18,3.25,1.29,6.66,2.27,9.72,3.91,1.51.81,2.4,2.78,3.57,4.22l-.02.02c.47.62.93,1.24,1.4,1.87,4.11,3.11,8.42,3.66,13.66,2.89,3.29-.48,7.01,2.15,10.57,3.25,11,3.4,22.03,6.73,33.05,10.08,4.9.01,9.79.02,14.69.04.25-.13.51-.16.78-.1,8.6-2.3,17.52-3.79,25.72-7.09,15.98-6.43,28.51-17.47,38.05-31.85l-.03.02Z"
  />
  <path
    class="cls-7"
    d="m563.66,838.76c-6.68-2.25-11.29-.34-14.19,5.93-.46.99-1.44,2-2.43,2.42-5.72,2.43-11.54,4.65-17.28,7.05-.92.39-1.63,1.31-2.43,1.98.69.74,1.28,1.61,2.08,2.2,8.61,6.43,17.2,12.87,25.92,19.14,1.25.9,3.16.86,4.76,1.28,1.71.44,3.41.91,5.11,1.37.27.02.55.03.82.05,1.34-.04,2.69-.07,4.03-.11,4.32-4.27,8.63-8.55,12.95-12.82h.1v-9.89c.01-.27.02-.55.03-.82,1.22-7.2,2.46-14.39,3.65-21.59.19-1.13.2-2.29.29-3.44-1.28.16-2.67.05-3.83.51-5.28,2.11-10.46,4.45-15.74,6.53-1.15.45-2.7.6-3.84.21Z"
  />
  <path
    class="cls-8"
    d="m189.55,923.5v-1.64c-.12-.24-.15-.5-.11-.77-.23-2.74-.46-5.48-.69-8.22v-6.54c.7-4.19-1.59-6.69-4.29-9.65-4.59-5.02-8.26-10.87-12.32-16.37-.18-.26-.35-.53-.53-.79-.19-.29-.39-.58-.58-.87-.18-.16-.26-.36-.26-.61-.24-.36-.49-.72-.73-1.08-.14-.12-.16-.26-.06-.41-.28-.42-.57-.83-.85-1.25v.04c-4.21-9.66-7.17-19.62-7.41-30.25-.11-.26-.11-.53,0-.8l.06.06c0-5.6-.02-11.2-.03-16.8,0-.69,0-1.37-.02-2.05,0-.27,0-.55,0-.82.47-4.29,1.13-8.57,1.28-12.88.04-1.19-1.23-3.31-2.21-3.52-8.71-1.82-17.48-3.4-26.27-4.73-1.06-.16-3.26,1.41-3.49,2.49-1.36,6.45-2.3,12.99-3.38,19.5-.07.53-.14,1.06-.21,1.59.07,7.35.13,14.7.2,22.05,0,.27,0,.55,0,.82.12.21.14.42.05.65v.09c.21,1.66.42,3.32.64,4.98,0,.54.02,1.09.02,1.63.27.9.62,1.78.8,2.69,2.09,10.79-.82,14.27-12.15,14.59-2.24-.03-4.47-.06-6.71-.08l.02.08-.38.07-.38-.09-21.11-2.63c-.18.38-.36.75-.53,1.13,7.24,4.51,14.48,9.01,21.72,13.52.27-.01.52.05.74.19,15.34,4.77,30.75,9.41,41.23,22.91.32.41.48.95.71,1.42.16.3.31.61.47.91.1.19.14.4.12.62.27.07.51.18.74.33,3.81,4.31,7.62,8.63,11.43,12.94.37.49.74.99,1.12,1.48,2.1,1.66,4.19,3.32,6.29,4.98,6.31,3.47,12.61,6.95,18.94,10.38.62.34,1.42.35,2.14.51-.05-.87.01-1.77-.17-2.62-1.25-5.74-2.56-11.46-3.85-17.19h-.02Z"
  />
  <path class="cls-2" d="m279.14,800.39s0,.02.01.03c.03,0,.05.02.07.03,0,0-.09-.06-.08-.06h0Z" />
  <path
    class="cls-3"
    d="m516.66,1022.75c-8.31-5.87-16.65-11.7-24.98-17.54-.62-.56-1.24-1.11-1.86-1.67-2.28-3.54-5.41-4.76-9.65-4.26-4.01.46-8.11.22-12.17.29h0c-.26-.09-.51-.09-.77,0-4.09-1.67-8.18-3.35-12.27-5.02h-3.27c-.23.16-.48.22-.75.18-7.06,6.37-15.71,4.91-23.97,4.53-4.65-.22-8.12.79-10.52,4.83-.26.19-.53.37-.79.56-.21.18-.43.36-.64.54l-.04.03c-8.41,5.96-16.81,11.92-25.22,17.87-4.63,3.27,1.76,2.49,1.51,4.14.29.06.58.13.88.19.3.2.6.4.9.6l-.04-.14c7.59,1.92,15.18,3.84,22.77,5.77,8.16.03,16.33.06,24.49.1h.82c1.46.36,3.05.48,4.37,1.14,2.17,1.08,4.18,2.5,6.25,3.77,3.02-.96,6.06-1.9,9.07-2.9,1.89-.63,3.75-1.34,5.63-2.01,8.15-.04,16.29-.08,24.44-.11,8.65-2.53,17.3-5.03,25.93-7.61.67-.2,1.19-.92,1.78-1.4-.62-.62-1.18-1.35-1.89-1.85v-.03Z"
  />
  <path
    class="cls-22"
    d="m103.03,772.37c8.22-1.11,15.04,3.57,22.52,5.5,5.05,1.3,10.04,2.84,15.06,4.28.54.05,1.07.1,1.61.15l8.98,1.6c.56.04,1.12.08,1.68.12,5.17,1.02,10.34,2.04,15.51,3.06h-.02c.28-.05.54,0,.8.12,13.72,2.27,27.45,4.41,41.13,6.88,3.53.64,6.88,2.3,10.32,3.5.17.22.39.37.66.43,3.25,2.12,6.49,4.24,9.74,6.36-.05.25-.01.5.1.73-.2.54-.41,1.08-.61,1.63.1.26.1.52,0,.78,3.12,5.91,8.06,8.28,14.62,7.5,1.33,1.59,2.67,3.17,4,4.76.58.61,1.17,1.22,1.75,1.83.5.03.99.07,1.49.1.25.7.5,1.41.75,2.11.34.33.68.67,1.02,1l3.18,3.18c.27.01.55.03.82.04.06-.08.11-.17.16-.26-.05.09-.1.18-.16.26.5.54,1,1.09,1.5,1.63h0c1.7,2.37,3.4,4.74,5.1,7.1.33.59.65,1.17.98,1.76,1.28,2.5,2.56,4.99,3.85,7.49l2.52,22.89c-.16,1.63-.33,3.26-.49,4.9-.42,1.87-.85,3.73-1.27,5.6-.27.82-.54,1.63-.81,2.45-.2.28-.4.57-.6.85-2.23,4.14-4.47,8.28-6.67,12.44-1.68,3.18-3.32,6.38-4.97,9.58-.01,3.54-.03,7.08-.04,10.62.03.27.05.54.08.82,3.02,5.52,5.89,11.12,9.19,16.47.5.81,3.4,1.14,4.43.48,19.04-12.09,29.55-29.91,34.17-51.6.68-3.17,1.29-6.36,1.94-9.53.05-.79.09-1.58.14-2.37-1.47-10.62-2.9-21.24-4.48-31.84-.18-1.2-1.19-2.28-1.82-3.42h0s-.02.03-.03.05c-.02-.26-.08-.5-.2-.72.06.24.13.49.19.73h0c-.06-.24-.13-.49-.19-.73-4.08-7.35-8.15-14.71-12.23-22.06-.36-.53-.71-1.05-1.07-1.58-2.61-3.01-5.23-6.02-7.84-9.03-.2-.14-.31-.34-.35-.58-.24-.06-.45-.17-.61-.35-.24-.24-.49-.47-.73-.71l-.03-.04-.75-.78-.06-.04c-.54-.53-1.09-1.06-1.63-1.59h0c-.3-.26-.6-.51-.9-.76l.07.03c-.25-.3-.49-.61-.74-.91l-.05-.05c-.28-.25-.55-.51-.83-.76h-.01c-.26-.28-.52-.55-.78-.82l-.04-.03c-.28-.26-.55-.52-.83-.78h0c-.24-.29-.48-.58-.72-.86l-.07-.07c-1.66-2.4-4.08-4.59-4.83-7.25-1.48-5.19-6.63-8.83-12.14-7.81-1.03.19-2.45-.25-3.32-.89-10.7-7.93-22.94-12.08-35.78-14.76-7.41-1.54-14.86-2.89-22.29-4.32l-.04-.04c-.4-.24-.79-.49-1.19-.73-.69-.03-1.39-.07-2.08-.1-7.23-1.01-14.53-1.7-21.68-3.11-12.59-2.49-25.29-4.74-37.54-8.43-7.05-2.13-13.31-6.89-19.92-10.46l-.05-.04c-.26-.25-.51-.51-.77-.76l-.05-.04c-.29-.25-.57-.5-.86-.75-.28-.27-.55-.55-.83-.82l.04.04c-.29-.29-.57-.57-.86-.86l.02.03c-7.98-7.43-10.61-17.32-12.35-27.52-.61-3.57-.48-7.26-.68-10.9v-1.63c1.04-6.66,1.59-13.44,3.3-19.92,1-3.77,1.27-6.28-1.65-9.35-5.58-5.86-10.64-12.21-15.89-18.38-1.96-2.31-3.48-4.36-5.22.41-1.99,5.45-4.43,10.79-7.23,15.87-.92,1.67-3.7,3.47-5.42,3.28-3.25-.36-6.85-1.47-9.4-3.43-6.05-4.66-11.56-10.03-17.32-15.07-1.27-1.11-2.67-2.06-4.02-3.08,1.91,9.93,6.07,19.04,12.2,26.86,10.95,13.95,19.12,28.83,19.89,46.98.05,1.19.43,2.38.66,3.56,3.52,10.8,7.51,21.34,14.87,30.28,3.24,3.93,1.27,7.9-1.67,10.47-4.31,3.77-9.18,7.08-14.25,9.74-4.84,2.54-10.24,4.04-15.43,5.89-2.76.98-1.66,1.7.03,2.51.82-.02,1.63-.03,2.45-.05h17.96c.27.01.54.02.82.02,1.02-.05,2.04-.11,3.06-.16l26.34-4.77c1.91-.01,3.81-.03,5.72-.04h-.03Zm187.34,52.29s.02-.03.03-.05c-.02,2.41-.03,3.62-.03,4.71v-4.66h0Z"
  />
  <path class="cls-23" d="m30.36,640.96c-.15-.19-.3-.37-.45-.56.13.2.26.41.38.61l.07-.05Z" />
  <path class="cls-21" d="m30.29,641.02s.06.05.1.07c0-.04-.02-.08-.03-.13l-.07.05h0Z" />
  <path
    class="cls-20"
    d="m383.29,318.65c-.79.16-1.57.32-2.36.47.04.2.08.4.11.6.79-.15,1.58-.29,2.37-.44-.04-.21-.08-.42-.12-.63Z"
  />
  <path
    class="cls-10"
    d="m350.27,907.93c-3.13,8.24-6.29,16.48-9.38,24.74-.47,1.25-.68,2.59-1.01,3.89v.83c-.07.57-.14,1.13-.21,1.7-.2.92-.4,1.84-.6,2.76-.02,3.68-.05,7.36-.07,11.04.11.25.14.51.09.79.54,2.78,1.36,5.54,1.55,8.35.2,3.03,1.79,3.67,4.28,3.28,3.72-.58,7.43-1.25,11.15-1.89v.04c.3-.21.59-.43.89-.64l.79-.2c7.9-4.58,14.56-10.25,17.1-19.52.05-.54.11-1.09.16-1.63.73-10.26,4.74-19,12.12-26.18v.05c.27-.36.55-.72.83-1.07-.01-.28.09-.5.31-.68.05-.2.18-.31.39-.32.28-.14.56-.27.84-.41.09-.23.14-.47.15-.72.26-.03.53-.06.79-.08h0c2.77-2.33,5.53-4.65,8.3-6.98,1.59-.61,3.18-1.23,4.77-1.84.42-.07.84-.13,1.26-.2.4-.28.79-.56,1.19-.84h-.06c.01-.22.05-.44.1-.65,5.4-.91,10.8-1.82,16.2-2.73v.06c7.03-.16,14.06-.39,21.09-.41.88,0,1.87.96,2.63,1.67,4.36,4.08,10.72,4.08,14.88.02.74-.72,1.73-1.67,2.6-1.67,7.04,0,14.07.2,21.11.34,12.15.62,23.04,4.27,31.72,13.22,9.27,7.64,14.45,17.43,15.45,29.42.03.27.05.54.08.81,2.15,9.79,9.01,15.6,17.14,20.34.26.07.52.13.79.2.3.21.6.43.9.64v-.04c3.28.61,6.56,1.19,9.84,1.82,3.61.69,5.6-.56,5.9-4.43.19-2.39.84-4.73,1.28-7.1,0-4.01,0-8.01-.01-12.02-.19-.85-.37-1.7-.56-2.55-.08-.85-.15-1.71-.23-2.57-.11-.25-.14-.5-.08-.76-2.94-8.52-5.11-17.4-8.99-25.47-7.9-16.45-20.2-29.23-36.94-36.69-9.52-4.24-19.91-6.52-29.9-9.68-.27,0-.55-.02-.82-.02-2.18-.02-4.36-.05-6.54-.07h-17.96c-2.47-1.33-4.93-2.66-7.4-3.99h.02c-.29-.22-.57-.43-.86-.65-2.96.22-5.91.44-8.87.66-2.46,1.33-4.93,2.65-7.39,3.98h-.81c-8.17.03-16.34.06-24.51.08-8.07,2.21-16.47,3.63-24.16,6.78-18.08,7.42-32.07,19.8-41.34,37.22v-.03Zm23.62-22.51c-.09.09-.17.18-.25.27.09.07.18.15.26.23-.09-.08-.18-.17-.26-.23.08-.09.17-.18.25-.27Z"
  />
  <path
    class="cls-16"
    d="m242.36,401.54c25.71-25.4,54.82-46.3,87.6-61.58,15.26-7.11,31.34-12.44,47.05-18.59.33-.13.59-.47.65-1.17-45.84,9.85-87.7,28.52-125.21,56.84-.27.05-.54.11-.81.16-8.72,7.73-17.7,15.19-26.11,23.24-15.72,15.03-30.17,31.25-42.37,49.31-7.66,11.34-14.71,23.08-22.03,34.64,0,.26-.08.48-.26.66-.22.3-.45.61-.67.91,0,.28-.09.53-.27.75-.18.31-.36.61-.54.92,0,.27-.07.51-.24.72-.21.49-.42.97-.63,1.46l-.02.03c-.23.31-.47.62-.7.93l.06.02c-1.12,2.17-2.25,4.35-3.37,6.52l.07-.04c.04.27,0,.53-.15.76-.46,1.36-.92,2.73-1.38,4.09-.06.28-.12.56-.19.84-.49,1.09-.98,2.18-1.47,3.27l-.11.13c-.27.75-.55,1.5-.82,2.25l-.16.82c-.33,1.07-.67,2.15-1,3.22l.25-.04c-.29.32-.58.65-.87.97-.26.73-.51,1.46-.77,2.2-.17.31-.33.61-.5.92l-.33.78c-.15.55-.31,1.1-.46,1.66-2.26,8.06-4.3,16.19-6.86,24.15-1.76,5.48-4.26,10.72-6.42,16.07-.15.31-.29.62-.44.93-2.48,4.27-5.12,8.45-7.36,12.85-.83,1.63-1.62,4.33-.86,5.53,4.66,7.27,9.9,14.16,14.67,21.35,2.07,3.13,3.44,1.76,4.79-.24,4.32-6.38,8.52-12.85,12.77-19.28.09-.3.19-.6.28-.9.2-.47.4-.94.6-1.41l.07-.07c.17-.31.35-.61.52-.92,3.47-7.65,6.66-15.44,10.48-22.92,4.74-9.28,12.01-16.01,21.34-21,5.25-2.81,9.48-7.52,14.17-11.37.9-1.11,1.81-2.23,2.71-3.34.44-.47.89-.93,1.33-1.4.24-.39.48-.79.72-1.18l.04-.03c.22-.25.45-.49.67-.74.14-.19.23-.4.25-.64-.4-.68-.79-1.36-1.19-2.04-.21.03-.4.13-.56.27-.57.18-1.13.36-1.7.54-.52.37-1.05.74-1.57,1.1-1.93.77-3.87,1.55-5.8,2.32-.28,0-.51.11-.69.32-.14.63-.3,1.19-.51,1.62.21-.43.37-.99.51-1.62-1.12.38-2.25.76-3.37,1.14-2.42.35-4.85.7-7.27,1.05-.74.02-1.47.03-2.21.05-.65,0-1.3,0-1.96-.01l.02.08-.39.03-.37-.13c-1.3-.04-2.6-.08-3.9-.12-5.31-6.08-.75-12.07.91-17.48,11.93-38.81,33.58-71.78,62.3-100.15h.04Zm-73.98,111.35h0c.1-.14.21-.28.31-.43-.1.14-.21.28-.31.43Zm1.32-1.81c.25-.34.52-.71.82-1.12-.3.41-.57.78-.82,1.12Z"
  />
  <path
    class="cls-18"
    d="m214.32,509.36c-.21-.16-.41-.33-.62-.49-1.6,1.22-3.19,2.44-4.79,3.66.4.68.79,1.36,1.19,2.04,1.41-1.74,2.82-3.47,4.23-5.21h-.01Z"
  />
  <path
    class="cls-19"
    d="m364.27,848.5c-.27-.08-.54-.15-.81-.22-.29-.24-.58-.48-.87-.73v.1c-2.91-.09-5.05-.71-5.83-4.25-.78-3.55-7.66-6.83-11.55-5.24-4,1.64-7.03.04-10.32-1.33-3.98-1.66-7.88-3.51-11.89-5.1-1.02-.4-2.29-.15-3.45-.19.05,1.03,0,2.08.18,3.09,1.24,7.31,2.52,14.6,3.79,21.9,0,.27.01.55.02.82.03.51.05,1.03.08,1.54-.01,2.79-.02,5.57-.04,8.36l.11.02c4.71,4.77,7.69,11.6,15.31,12.9.52-.03,1.05-.06,1.57-.1,1.08-.53,2.39-1.76,3.21-1.49,5.31,1.74,7.92-2,11.43-4.72,7.11-5.5,14.7-10.38,22.07-15.55.85-.59,1.56-1.39,2.33-2.09-.94-.71-1.78-1.62-2.82-2.11-4.14-1.95-8.34-3.76-12.52-5.62h0Z"
  />
  <path class="cls-11" d="m894.96,516.75l.03-.03.04-.04-.08.07h.01Z" />
  <path class="cls-17" d="m725.37,731.51s-.01-.05-.02-.08h-.02l.04.08h0Z" />
  <path class="cls-13" d="m4.21,511.92c.12.11.23.22.35.33-.11-.12-.22-.23-.33-.35l-.02.02h0Z" />
  <polygon class="cls-14" points="4.02 511.71 4.21 511.92 4.23 511.9 4.02 511.71" />
  <path
    class="cls-12"
    d="m.06,384.59l-.04.04c7.38,10.61,15.1,21.01,22.07,31.88,11.39,17.76,22.3,35.82,33.42,53.76.06.27.12.53.18.8.26.28.53.56.79.84l7.35,14.7c.27.55.54,1.09.81,1.64,2.41,5.55,4.82,11.1,7.23,16.65.04.44.09.87.13,1.31.54,2.18,1.09,4.36,1.63,6.54.09.3.18.6.26.9.17.84.33,1.68.5,2.51.02,3.5.29,7.01,0,10.48-.57,6.88-5.27,10.82-12.19,10.59l-.39.1h-.41l.05-.04c-2.22,0-4.44-.02-6.66-.02-1.07-.04-2.14-.07-3.21-.11h-.81c-9.23-.21-16.89-4.8-24.57-9.11-4.55-2.56-8.71-5.81-13.05-8.75-.26-.26-.53-.52-.79-.79l-.03-.03-.78-.7c-.19-.13-.4-.2-.63-.22-.33-.24-.66-.48-.99-.72h0c-.28-.26-.55-.52-.83-.77l-.03-.04-.66-1.03c-.3-.21-.6-.42-.9-.64-.81-.55-1.63-1.1-2.44-1.64h0c-.17-.15-.33-.31-.5-.46.16.17.31.33.47.5.57,1.06,1.13,2.13,1.7,3.19l.03.03c.27.52.54,1.04.81,1.56l.05.05c.49.59.98,1.19,1.47,1.78,5.13,7.21,10.16,14.49,15.42,21.61,2.22,3.01,4.89,5.68,7.36,8.5.13.24.26.48.39.72.24,0,.45.07.63.24.25.22.5.44.76.66.27.27.55.55.82.82.31.55.62,1.1.93,1.65l-.02-.17c18.3,12.58,33.49,27.56,43.36,48.16,5.59,11.67,14.42,21.85,22.28,32.34,10.05,13.42,21.31,25.97,30.68,39.83,8.33,12.33,14.45,26.05,14.74,41.52-.02,1.81-.03,3.62-.05,5.43v4.19c.56.55,1.06,1.47,1.7,1.59,9.17,1.75,18.36,3.47,27.58,4.98,1.13.19,3.29-.56,3.57-1.36,4.77-13.69,14.6-23.91,23.37-34.89,3.36-4.2,5.98-8.99,8.94-13.51h0c.87-1.96,1.82-3.9,2.59-5.91.31-.8.26-1.74.37-2.62-.79.33-1.7.5-2.35,1.01-5.29,4.15-10.4,8.53-15.82,12.5-5.5,4.02-11.58,6.41-18.56,4.24-.95-.3-2.3-.94-2.53-1.7-2.67-8.71-5.16-17.48-7.7-26.23-.01-.71-.02-1.42-.04-2.12.5-7.12.18-14.42,1.67-21.33,2.64-12.26,3.36-24.41,1.26-37.54-3.31,7.95-5.75,15.55-9.57,22.36-2.59,4.63-6.9,8.43-10.98,11.99-.99.86-4.97,0-6.12-1.32-11-12.72-21.94-25.51-32.38-38.68-6.79-8.56-10.18-18.71-10.69-29.71-.05-1.52-.09-3.05-.14-4.57.02-2.84.04-5.67.06-8.51.08-2.21.17-4.42.25-6.63.17-.54.35-1.08.52-1.62l-.08.02c-.05-.26-.02-.5.09-.74l1.68-11.43c4.39-11.78,8.53-23.67,13.24-35.33,9.22-22.83,21.51-44.07,35.99-63.89,9.97-13.64,21.22-26.34,31.9-39.47,1.1-1.01,2.19-2.02,3.3-3.02,12.77-11.5,25.28-23.31,38.4-34.39,8.13-6.87,17.18-12.65,25.82-18.92,3.48-2.25,6.96-4.51,10.45-6.76l.12-.07,1.57-.71.06-.05c.31-.24.62-.48.93-.72.28-.12.56-.23.83-.35.27-.07.45-.24.55-.5l.09-.1c.92-.47,1.85-.94,2.77-1.42.73-.38,1.45-.76,2.18-1.13.59-.39,1.18-.78,1.77-1.18.25-.13.49-.25.74-.38.53-.22,1.06-.45,1.59-.67h0c3.95-2.06,7.82-4.31,11.88-6.14,10.92-4.94,21.86-9.85,32.91-14.47,7.3-3.05,14.83-5.58,22.25-8.34,11.51-2.89,22.93-6.31,34.57-8.53,13.11-2.5,26.42-3.93,39.64-5.82l1.42-.08c5.79-.5,11.58-.99,17.36-1.49,10.61-.04,21.23-.08,31.84-.11h.82c5.75.53,11.49,1.05,17.24,1.58,1.88.06,3.75.12,5.63.18,3.54.5,7.08,1,10.62,1.5,1.36.1,2.72.2,4.08.31,2.18.45,4.36.9,6.54,1.35.27.01.54.02.82.03,2.5.51,5.01,1.02,7.51,1.53h.34l.32.11c.27.02.54.04.82.06,6.57,1.28,13.23,2.23,19.7,3.91,10.65,2.76,21.17,6,31.75,9.03,12.55,5.32,25.27,10.29,37.62,16.04,26.13,12.17,50.31,27.54,72.67,45.74.2.16.5.18.76.27,11.97,11.13,23.97,22.24,35.89,33.42,3.11,2.92,6.02,6.06,9.02,9.1,6.84,8.74,13.93,17.3,20.48,26.24,16.42,22.4,30.09,46.38,40.66,72.1.72,1.74,1.18,3.59,1.77,5.39.11.23.19.47.25.71,5.48,11.73,9.95,23.77,11.24,36.78.16.81.32,1.62.48,2.43.08,2.21.16,4.43.24,6.64.18.05.36.08.55.09-.16,3.3-.33,6.6-.49,9.91-.05,1.03-.11,2.05-.16,3.08.07.27.06.53-.02.79-.31,10.23-3.59,19.65-9.76,27.57-10.3,13.22-21.32,25.89-32.07,38.76-3.64,4.36-6.83,5.01-10.75.66-4.19-4.65-7.51-10.2-10.57-15.71-2.08-3.74-3.03-8.09-4.58-12.14-.37-.96-1.11-1.78-1.68-2.66-.49.9-.98,1.81-1.47,2.71-.01.54-.02,1.09-.04,1.63-1.04,14.2,1.53,27.99,4.62,41.74.41,1.81.22,3.75.31,5.63,0,2.18.01,4.36.02,6.53-.78,3.92-1.22,7.95-2.43,11.73-1.44,4.5-3.91,8.67-5.24,13.19-1.07,3.64-3.55,4.97-6.55,4.75-3.68-.27-7.83-.7-10.81-2.59-8.17-5.16-15.83-11.12-23.46-16.6,1.09,2.71,2.36,5.89,3.64,9.07l-.1-.02c.26.3.51.6.77.89l.03.04c5.44,7.61,10.88,15.23,16.33,22.84l.02.02c.28.26.56.52.83.78h0c7.15,7,11.58,15.52,13.98,25.17,9.39-1.43,18.81-2.73,28.16-4.39,1.84-.33,3.44-2.06,5.15-3.15v-.07c0-1.82.02-3.63.03-5.45.02-.77.04-1.54.06-2.31v-.81c2.03-8.51,3.08-17.4,6.27-25.44,8.64-21.78,24.15-38.96,39.4-56.28,9.39-10.66,17.52-22.1,23.62-35.22,7.29-15.69,18.75-28.39,32.99-38.51,4.61-3.28,8.63-7.39,12.93-11.12,7.32-9.54,14.64-19.09,21.96-28.63.22-.28.45-.56.67-.84l.1-.11c.19-.22.39-.43.58-.65.09-.29.18-.58.27-.87.25-.54.5-1.08.74-1.62l.02-.04c.41-.78.83-1.56,1.24-2.33-.9.55-1.8,1.1-2.7,1.65l-.07.06c-.28.23-.56.46-.84.69h0c-.3.25-.61.49-.91.73-.29.28-.57.57-.86.85l.08-.1-1.42,1.05-.12.11c-.28.21-.57.42-.85.62-9.57,7.18-19.72,13.35-31.22,16.91-2.27.7-4.77.67-7.17.98-3.54.04-7.08.09-10.62.13-3.46-1.14-6.92-2.29-10.38-3.43-.66-3.78-1.32-7.56-1.98-11.33,0-.54.01-1.08.02-1.63.91-11.41,4.73-21.93,9.77-32.09.23-.78.35-1.6.69-2.32,14.36-29.83,32.64-57.27,51.63-84.27,3.9-5.54,7.99-10.95,11.99-16.42-1.52-.25-2.41.04-3.11.57-17.72,13.23-36.58,24.6-56.47,34.23-12.29,5.95-24.82,11.45-38.61,12.92-8.02.86-16.11,1.13-22.98-4.25-5.77-4.52-8.26-10.95-9.83-17.83-.05-6.52-.09-13.04-.14-19.57-.28,1.84-.59,3.68-.89,5.52.3-1.84.61-3.68.89-5.52.05-.52.11-1.04.16-1.55.68-2.73,1.36-5.46,2.04-8.19.12-.45.24-.91.36-1.36.18-.64.36-1.27.54-1.91.1-1.26.2-2.52.3-3.78.73-1.74,1.46-3.48,2.19-5.23.17-.18.26-.39.29-.63,3.3-8.75,6.6-17.51,9.9-26.26-.02.02-.03.04-.05.06,1.29-2.5,2.58-5,3.87-7.49-.11-1-.17-2.02-.26-3.03.09,1.01.15,2.02.26,3.03h0c4.87-8.95,9.74-17.91,15.14-27.85-1.67.71-2.26.9-2.79,1.19-20.72,11.39-41.55,22.48-64.03,30.21-11.04,3.8-22.07,6.56-33.82,5.33-5.86-2.94-8.29-7.85-7.75-14.19.53-6.17,1.37-12.31,2.08-18.47,4.26-15.76,8.51-31.52,12.77-47.28l3.78-11.61c.1-.49.2-.97.3-1.46.27-.54.55-1.08.82-1.61.03-.29.07-.59.1-.88l.72-2.39h.01c1.8-4.97,3.6-9.93,5.4-14.89.14-.51.27-1.02.41-1.54.24-.27.47-.54.71-.81l-.11.05c.28-.82.57-1.65.85-2.47.12-.59.24-1.17.37-1.76.17-.34.33-.68.5-1.03-.09-.16-.07-.31.03-.45.52-1.16,1.04-2.32,1.56-3.48-.06-.2-.04-.4.04-.59,1.08-2.75,2.16-5.49,3.24-8.24l-.03.06c1.6-4.19,3.2-8.37,4.81-12.56.11-.46.21-.93.32-1.39.22-.27.44-.54.66-.82l-.16.03c.56-1.37,1.12-2.74,1.68-4.1,0-.26.05-.52.14-.76.77-1.97,1.54-3.94,2.31-5.91.02-.27.12-.51.29-.72.2-.37.4-.73.61-1.1.08-.46.17-.92.25-1.38.21-.48.41-.97.62-1.45l.05-.05c.76-1.73,1.53-3.45,2.29-5.18.34-1.03.69-2.06,1.03-3.09.23-.27.46-.53.69-.8l-.11.05c-.92-1.12,2.85-3.96-1.41-3.86l.08-.15c-.9,1.3-1.8,2.61-2.69,3.91l-.07.1c-.24.25-.47.49-.71.74l-.07.06c-3.22,3.57-6.45,7.15-9.67,10.72l.02-.07c-.29.29-.59.59-.88.88l.06-.06c-.29.3-.59.6-.88.89l.08-.08c-.3.29-.59.59-.89.88l.06-.03c-1.4,1.58-2.8,3.15-4.2,4.73l-.11.12c-.23.23-.45.46-.68.69l-.12.13c-.23.24-.47.47-.7.71l-.09.08c-.8.79-1.6,1.59-2.39,2.38l-.06.1c-.24.27-.47.55-.71.82h0c-2.97,3.29-5.94,6.58-8.91,9.87v-.06c-.28.28-.56.55-.83.83-.29.23-.59.47-.88.7l-.1.1c-.24.25-.48.5-.71.75l-.05.07c-.24.28-.47.57-.71.85-.29.29-.58.58-.86.87l.08-.07c-.3.26-.6.52-.9.78l-.05.03c-.26.29-.51.58-.77.88l.06-.06c-.29.3-.58.59-.88.89l.07-.07c-.3.3-.59.59-.89.89h.13c-.58.53-1.16,1.08-1.74,1.63l.04-.04-9.81,9.86.02-.1-.89.88.06-.06c-.29.29-.58.59-.87.88-.27.27-.55.54-.82.82l.06-.07c-.29.3-.59.59-.88.89l.08-.03c-1.12,1.07-2.24,2.14-3.35,3.2v.02c-.26.28-.51.56-.76.84-.29.25-.58.49-.86.74l-.05.05c-.25.26-.51.51-.76.77l-.05.03c-3.26,2.99-6.51,5.97-9.77,8.96l-.04.04c-.25.26-.51.51-.76.77l-.05.05c-.24.29-.49.57-.73.86-.29.23-.58.47-.86.71l-.06.04c-2.14,1.93-4.29,3.86-6.43,5.8l.02-.04c-.29.29-.57.57-.86.86l.04-.04c-.28.28-.56.55-.83.83-.26.23-.53.45-.79.68-.21.13-.43.2-.68.19-2.75,2.28-5.5,4.57-8.25,6.85.03.18-.02.34-.16.46l-.77.68c-4.89,3.92-9.78,7.84-14.67,11.76h0c-4.13,2.23-8.22,4.54-12.41,6.65-1.4.71-3.05.92-4.58,1.36-4.23,2.68-10.2,2.01-13.55-1.75-5.8-6.51-8.91-14.31-10.43-22.8l.09.06c-.23-.56-.46-1.12-.7-1.67-.04-.52-.07-1.05-.11-1.57-.2-.54-.41-1.09-.61-1.63-.09-.52-.19-1.04-.28-1.56-.27-1.43-.54-2.86-.81-4.29-.07-.15-.07-.3.02-.45-.25-.65-.5-1.31-.75-1.96-.03-.49-.06-.98-.1-1.47-.27-1.42-.55-2.83-.82-4.25-.03-.51-.06-1.02-.1-1.53-.51-3.28-1.03-6.57-1.54-9.85l.06.02c-.5-5.73-1-11.46-1.5-17.19v-1.66c-.06-1.9-.11-3.8-.16-5.7-.08-.18-.09-.37-.03-.56-.26-2.54-.52-5.09-.78-7.63-.01-.54-.02-1.09-.03-1.63,0-1.25.01-2.51.02-3.76-.26-3.11-.52-6.22-.78-9.32,0-.54,0-1.08-.01-1.62.03-1.63.06-3.27.1-4.9.03-.56.05-1.11.08-1.67-.26-1.49-.51-2.98-.77-4.47-.83.49-1.66.98-2.49,1.47-.06.27-.2.5-.41.69-.96,1.44-1.92,2.89-2.88,4.33,0,.19-.08.35-.23.48l-3.85,5.9c-.11.25-.23.5-.34.75-.19.24-.37.48-.56.72-.28.29-.56.57-.84.86l.08-.05c-3.02,4.35-6.04,8.71-9.06,13.06h0c-.29.51-.57,1.04-.86,1.56l-.03.03c-.82,1.05-1.63,2.1-2.45,3.15l-.09.14c-.23.25-.45.5-.68.74l-.07.08c-.24.28-.49.56-.73.84l.02-.02c-.3.49-.6.98-.9,1.47l-.1.1c-1.55,1.7-3.11,3.39-4.66,5.09v-.13c-.3.3-.6.59-.89.89h.13c-.18.64-.16,1.48-.57,1.89-7.61,7.66-15.26,15.27-22.94,22.85-.42.41-1.25.41-1.88.6l.02-.1c-.29.35-.58.71-.87,1.06-.22.23-.44.46-.67.68-5.6,4.37-11.72,7.3-18.94,8.16-6.89.83-10.49-2.7-13.07-8.26-.28-.59-.55-1.19-.83-1.78-.27-.5-.54-.99-.81-1.49-.11-.25-.13-.5-.07-.77-1-2.45-1.99-4.89-2.99-7.34-.09-.5-.18-1.01-.27-1.51-.51-1.42-1.03-2.84-1.54-4.25-.1-.24-.15-.48-.16-.74-1.87-6.03-3.75-12.05-5.62-18.08-.02-.44-.03-.88-.05-1.32-.53-2-1.05-4-1.58-6.01-.08-.19-.08-.38-.01-.58-.23-.62-.47-1.25-.7-1.87l-.03-.06c-.27-1.06-.54-2.12-.82-3.19-.05-.48-.1-.97-.14-1.45-1.25-5.48-2.51-10.97-3.76-16.45-.09-.57-.19-1.14-.28-1.71v-1.31c-.23-.66-.46-1.31-.7-1.97l-.02-.04c-.58-2.98-1.16-5.97-1.74-8.95-.08-.19-.08-.38,0-.57-.75-4.16-1.51-8.32-2.26-12.48-.06-.71-.12-1.42-.18-2.14-.24-.65-.48-1.29-.72-1.94-.03-.44-.06-.89-.09-1.33-.19-.62-.38-1.25-.57-1.87-.02-.84-.04-1.68-.06-2.52-.31-.89-.61-1.78-.92-2.67-.71-4.22-1.43-8.44-2.14-12.65-.11-1.15-.22-2.29-.32-3.44-.3-1.37-.6-2.74-.9-4.11-.07-.16-.07-.32.02-.47-.27-.67-.55-1.35-.82-2.02-.09-.17-.08-.33,0-.49-.29-2.25-.57-4.5-.86-6.75l.06.02-.69-4.15c-.02-.82-.04-1.64-.05-2.45-.32-1.05-.64-2.11-.95-3.16l.05-.04c-.25-1.66-.51-3.31-.76-4.97-.03-.76-.06-1.52-.08-2.28-.26-1.42-.52-2.84-.78-4.26-.09-.19-.11-.38-.07-.58-.26-1.42-.53-2.84-.79-4.26h.05c-.5-2.99-1-5.99-1.5-8.99-.05-.55-.1-1.1-.14-1.65-.03-.47-.06-.94-.09-1.42-.25-1.44-.5-2.89-.75-4.33-.08-.18-.07-.36.01-.54-.27-1.71-.53-3.42-.8-5.13h.01c-.55-3.83-1.11-7.66-1.66-11.5-.02-.45-.05-.9-.07-1.36-.25-1.44-.5-2.89-.75-4.33-.08-.21-.08-.43,0-.64-.21-1.69-.42-3.38-.64-5.07-.29-1.38-.58-2.76-.87-4.14-.3-2.71-.59-5.41-.89-8.12-.08-.21-.08-.42,0-.63-.19-1.14-.38-2.29-.57-3.43l-.12-.15c-.26-2.11-.52-4.23-.79-6.34-.04-.83-.07-1.67-.11-2.5-.02-.73-.04-1.45-.06-2.18-.5.52-.99,1.03-1.49,1.55-.03,1.08.03,2.18-.12,3.25-1.58,11.81-3.15,23.61-4.81,35.41-2.28,16.25-4.42,32.53-7.02,48.74-2.25,14.05-4.93,28.03-7.63,42-4.04,20.88-7.62,41.87-12.65,62.51-3.45,14.15-8.63,27.93-13.82,41.58-3.17,8.32-7.23,9.69-17.25,7.19-12.49-3.12-21.55-11.78-30.13-20.63-15.76-16.23-28.92-34.49-40.57-53.86-.56-.93-1.64-1.54-2.47-2.3-.23,1-.62,1.99-.67,3-.63,14.25-.95,28.53-1.89,42.76-.54,8.21-2.07,16.36-3.15,24.54-.32,3.5-.64,6.99-.96,10.49,2.84-.23,5.68-.5,8.52-.67-2.84.18-5.68.45-8.52.67l.16.04c-.19.28-.39.56-.58.83-.08.8-.17,1.6-.25,2.39-.29,1.43-.59,2.85-.88,4.28-.27.74-.54,1.47-.81,2.21-.41,1.39-.83,2.78-1.24,4.17-2.06,4.85-3.78,9.89-6.27,14.52-3.6,6.69-9.91,9.51-15.88,7.25-4.4-1.66-9-3.38-12.71-6.16-12.63-9.47-24.9-19.41-37.3-29.18-9.08-8.83-18.17-17.66-27.23-26.51-.35-.34-.43-.96-.64-1.45-7.58-7.49-15.32-14.84-22.7-22.52-8.79-9.15-17.28-18.59-26.71-27.62.41,1.42.72,2.88,1.26,4.25,7.08,18.18,14.25,36.32,21.26,54.53,3.16,8.2,5.99,16.53,8.97,24.81h0c.82,2.48,1.65,4.97,2.47,7.45.1.28.2.56.3.84.18.83.35,1.65.53,2.48,0,.27.09.52.24.74.2.34.39.68.59,1.02.32,1.01.64,2.03.96,3.04.22,1.14.43,2.28.65,3.41,0,.25.06.47.2.67.23.24.46.48.69.73l.03.03c.27.34.55.68.84,1.02-.28-.34-.57-.67-.84-1.02,1.32,4.64,2.64,9.28,3.96,13.92.08.55.15,1.1.23,1.64.2.61.4,1.22.61,1.82l.41,1.5c.41,1.38.82,2.77,1.23,4.15.08.51.17,1.01.25,1.52l.52,2.45.31,1.65c.19.37.38.75.57,1.12.55,2.87,1.1,5.73,1.65,8.6h0c-.07.28-.15.56-.22.83.08,1.09.15,2.18.23,3.27.25.35.5.7.76,1.04.12.51.23,1.02.35,1.53.16,1.38.32,2.77.49,4.15.07.77.13,1.54.2,2.31,0,3.22.01,6.45.02,9.67-1.26,7.55-5.51,11-13.22,10.72-1.36,0-2.72-.01-4.08-.02-8.2-1.87-16.6-3.13-24.56-5.75-10.19-3.35-20.02-7.8-30.01-11.77h0c-3.8-2.03-7.6-4.07-11.4-6.09-7.02-3.74-14.03-7.49-21.07-11.17-.73-.38-1.67-.36-2.51-.53.18.76.22,1.6.57,2.27,2.61,5.04,5.27,10.04,7.92,15.06.17.13.25.3.24.51.19.33.38.66.56.99.16.13.24.3.24.51.27.42.54.83.81,1.25.18.5.36,1,.53,1.49.19.18.29.41.31.67.18.33.36.66.54.98.18.19.27.41.28.67.22.34.44.69.66,1.03.15.23.2.49.17.77,5.21,12.82,11.03,25.44,15.4,38.54,2.78,8.33,3.43,17.38,5.03,26.11.02,1.9.05,3.8.07,5.7-.24,10.21-3.09,19.39-12.35,24.81-3.49,2.04-8.15,2.09-12.28,3.04-1.37.02-2.74.03-4.11.05-1.48-.06-2.97,0-4.43-.2-17.95-2.3-34.12-9.72-49.51-18.54-16.64-9.54-32.58-20.27-48.83-30.49H.45c-.15-.09-.3-.17-.45-.26.08.15.17.31.25.46,0,0,.02-.02.04-.04l-.23.03Zm803.63,148.03c.1-.15.2-.3.31-.45-.11.15-.21.3-.31.45-.1-.06-.22-.14-.35-.21.13.07.25.14.35.21Zm-89.96-299.43c-.25,2.53.08,5.06,1.72,7.6,2.52-1.79,3.79-.6,3.67,1.48.11-2.07-1.16-3.22-3.73-.93,0-.02.01-.14.03-.29,0-.09.02-.18.03-.26-.07.08-.15.15-.23.22-1.46-2.72-1.76-5.31-1.49-7.82h0Z"
  />
  <path class="cls-15" d="m453.24,0v.15s.08-.08.12-.12C453.36.03,453.24,0,453.24,0Z" />
  <path
    class="cls-25"
    d="m867.38,647.48c-.3.24-.6.48-.89.72l-.06.05c-6.4,4.76-12.52,10-19.32,14.12-4.23,2.56-7.59.4-9.3-4.26-1.3-3.55-2.7-7.06-4.05-10.59l.08.03c-.25-.3-.49-.6-.74-.9l-.05-.05c-.22-.53-.44-1.05-.66-1.58l-.1-.11c-3.77-4.75-3.73-4.72-7.89.27-1.36,1.63-2.95,3.05-4.44,4.57-.09.18-.23.28-.43.3-3.12,3.85-6.01,7.92-9.43,11.48-2.61,2.72-2.63,5.09-1.73,8.61,1.66,6.47,2.32,13.19,3.4,19.8,0,1.36.01,2.72.02,4.08v.82c-.62,13.34-3.26,25.95-13.03,35.98v-.03c-.27.28-.55.56-.82.84l.03-.05c-.29.3-.59.6-.88.89l.06-.04c-.29.26-.58.53-.87.79h.02c-7.23,6.75-16.1,10.7-25.45,12.86-16.21,3.75-32.65,6.54-48.98,9.76-14.06,2.78-28.3,4.93-42.1,8.67-7.64,2.07-14.51,6.93-21.82,10.34-1.61.75-3.61.65-5.43.94-.27.03-.53,0-.78-.11-.27,0-.54,0-.81.01-5.29,1.91-9.3,4.66-10.28,11-.35,2.27-3.4,4.11-5.22,6.15h0c-.29.24-.57.5-.86.75l-.03.02c-.25.28-.51.57-.76.85h0c-.28.24-.56.48-.85.72l-.09.07c-.23.28-.46.57-.68.85-.28.24-.57.49-.85.73l-.06.06c-.52.55-1.04,1.1-1.56,1.64h0c-3.65,4.02-7.3,8.05-10.95,12.07.18.23.34.46.5.68-.16-.23-.32-.45-.5-.68-2.61,3.87-5.22,7.74-7.83,11.61h0c-1.17,2.43-2.35,4.86-3.52,7.28h0c-2.61,9.3-5.22,18.61-7.82,27.91l.03-.05c.09.27.08.54-.02.8-.03,3.81-.06,7.62-.1,11.43l.14,2.42c2.18,11.61,4.64,23.15,10.56,33.58,6.31,11.11,14.28,20.68,25.26,27.59,2.33,1.47,3.87,1.34,5.02-.75,3.11-5.63,5.98-11.4,8.95-17.11,0-3.54-.01-7.08-.02-10.62-.01-.27-.03-.54-.04-.82-2.99-4.94-6.07-9.83-8.93-14.85-1.12-1.97-1.77-4.21-2.63-6.33h.02c-.21-.28-.42-.57-.63-.87-.29-.82-.58-1.64-.88-2.45-.39-1.87-.79-3.75-1.18-5.62-.2-1.83-.4-3.66-.6-5.49.01-2.58.02-5.17.03-7.75l-.09.05c-.1-.27-.09-.53.02-.8.64-12.62,6.14-22.97,14.83-31.83h.01c1.06-1.06,2.13-2.12,3.19-3.17.34-.33.67-.66,1.01-.99.75-.74,1.5-1.49,2.25-2.23.58-.61,1.16-1.21,1.74-1.82,1.65-3.22,3.98-4.67,7.89-4.97,2.88-.22,5.57-2.71,8.35-4.18h0c.56-.48,1.12-.96,1.68-1.43.27-.82.54-1.63.8-2.45.74-1.53,1.08-3.61,2.29-4.49,3.43-2.5,7.22-4.5,10.86-6.7h0c.26-.02.5-.09.73-.21,3.58-1.06,7.15-2.11,10.73-3.17v-.03c9.76-1.67,19.52-3.33,29.28-5,1.09-.07,2.17-.15,3.26-.22,7.4-1.23,14.8-2.45,22.19-3.68,1.59-.26,3.17-.54,4.76-.81l3.27-.15c9.8-3,19.6-6,29.41-9h0c3.26-.29,6.52-.57,9.78-.86,1.9,0,3.81-.02,5.71-.03.27,0,.55.01.82.02,1.64.02,3.28.05,4.91.07-1.39-2.56-3.11-3.59-4.98-3.9,1.87.31,3.59,1.34,4.98,3.9.53.02,1.06.04,1.59.07l4.86,1.29c.28.09.56.17.85.26,2.74.56,5.48,1.11,8.22,1.67l.38.08.39-.07c1.1.52,2.2,1.05,3.29,1.57.27,0,.54.01.82.02.54.02,1.09.03,1.63.05,6.26,0,12.52.02,18.78.02.27-.01.54-.02.82-.04.54-.01,1.09-.02,1.63-.03.26-.1.52-.14.79-.09-.31-.98-.62-1.96-.92-2.94-7.03-2.77-14.06-5.55-21.08-8.32-.4-.32-.8-.63-1.2-.95-.41-.24-.82-.48-1.23-.72-.41-.3-.81-.6-1.22-.9-.43-.29-.85-.58-1.28-.87h.11c-.44-.49-.84-1.03-1.33-1.49-5.5-5.17-5.59-8.43-1.53-14.52,3.17-4.74,5.59-9.99,8.34-15.01-1.29-.29-2.58-.6-3.87-.87,1.29.27,2.58.58,3.87.87l.11-.14h0c2.35-8.82,5.36-17.53,6.87-26.5,1.93-11.47,6.77-21.29,13.82-30.24,7-8.88,12.61-18.52,15.94-29.39.37-1.22.67-2.46,1.35-5.01-3.25,3.07-5.48,5.17-7.7,7.28l.02-.05.03.02Z"
  />
  <path
    class="cls-27"
    d="m665.2,841.41c-2.41-1.78-4.27-1.96-5.73,1.09-2.78,5.79-5.64,11.54-8.46,17.3-.05,3.27-.09,6.54-.14,9.81,3.58,6.26,7.15,12.51,10.73,18.77.15.14.18.31.11.51,1.28,5,2.55,9.99,3.83,14.99.06.43.11.86.17,1.29v10.24l.03-.03c-.59,12.39-6.02,22.5-14.68,31.08-9.33,9.36-21.8,12.79-33.51,17.62-.9.37-2.31-.35-3.44-.72-4.55-1.5-10.18.97-12.3,5.32-.56,1.14-1.31,2.67-2.33,3.04-9.76,3.57-19.57,7.03-29.45,10.28-1.98.65-4.3.26-6.46.35h-.8c-11.76-.16-22.43-3.35-31.37-11.34-.22-.03-.38-.15-.47-.36-10.57-7.89-15.94-18.7-17.66-31.54-.13-.84-.26-1.68-.39-2.53v-.82c-6.04-12.72-15.99-19.62-30.15-19.94-1.06-.02-2.79,1.53-3.11,2.65-.89,3.23-1.21,6.61-1.76,9.94-.02,2.99-.04,5.99-.06,8.98.53,4.08,1.06,8.17,1.59,12.25.07.47.14.94.21,1.42,1.05,3.07,2.1,6.13,3.16,9.2.03.26.07.52.1.79,4.92,11.69,11.3,22.44,20.4,31.39,13.46,13.25,29.54,21.28,48.26,23.96,1.33.19,2.62.61,3.93.92,5.16.02,10.32.05,15.48.07,8.01-2.15,16.04-4.27,24.03-6.48,1.79-.5,3.56-1.19,5.22-2.03,7.27-3.67,14.76-5.98,23.02-4.27.53-.12,1.07-.23,1.6-.35,6.76-11.92,20.23-12.94,30.71-18.78,14.23-7.94,25.94-18.29,33.65-32.84.43-.81,1.23-1.43,1.85-2.13l.03-.04c.25-.3.5-.6.75-.9l-.1.02c5-11.77,9.2-23.77,9.3-36.76.24-29.86-11.75-53.65-35.76-71.4l-.03-.02Z"
  />
  <path
    class="cls-26"
    d="m813.43,871.96c-.27.02-.55.05-.82.07-2.18.5-4.35,1.01-6.53,1.51-.27.03-.54.05-.8.08-1.09.02-2.19.04-3.28.07l-.37.15h-.4c-2.2.24-4.39.48-6.59.72-.45,0-.89.02-1.34.03-1.49,0-2.98-.01-4.47-.02v.1s-.37.03-.37.03l-.36-.13c-2.41-.3-4.89-.32-7.21-.94-5.11-1.38-6.94-4.87-5.86-10.07.88-4.23,1.52-8.51,2.27-12.77-.07-.27-.05-.52.08-.77.04-6.81.07-13.61.11-20.42-.02-1.36-.05-2.71-.07-4.07-1.13-6.53-2.13-13.09-3.53-19.56-.23-1.05-2.36-2.59-3.39-2.44-9.09,1.39-18.14,3.05-27.16,4.87-.73.15-1.65,2.04-1.57,3.05.3,4.16.95,8.29,1.47,12.43.01.54.02,1.09.03,1.63v22.1h0c-1.1,18.93-8.36,35.29-21.19,49.08-2.74,2.95-4.82,5.56-4.2,9.67v7.35c-1.25,8.25-2.5,16.49-3.75,24.74-.22,1.48-.44,2.97-.66,4.45,1.51-.49,3.06-.89,4.52-1.51,1.35-.57,2.6-1.38,3.89-2.08.3-.06.59-.13.89-.19,13.23-8.76,23.6-20.36,33.52-32.61,3.65-4.52,9.7-7.1,14.65-10.56.25-.1.51-.21.76-.31,5.99-2.37,12.17-4.37,17.94-7.2,9.43-4.64,18.59-9.82,27.86-14.78l-.72-1.68h-3.37l.02-.02Z"
  />
  <path
    class="cls-24"
    d="m204.99,327.35v3.27c.09,1.07.18,2.13.26,3.2,0-3.22-.01-6.45-.02-9.67-.08,1.07-.16,2.14-.24,3.21h0Z"
  />
</svg>`

export const foodIcon = html`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="15"
  height="20"
  viewBox="0 0 15 20"
  fill="none"
>
  <path
    d="M3 20V10.85C2.15 10.6167 1.4375 10.15 0.8625 9.45C0.2875 8.75 0 7.93333 0 7V0H2V7H3V0H5V7H6V0H8V7C8 7.93333 7.7125 8.75 7.1375 9.45C6.5625 10.15 5.85 10.6167 5 10.85V20H3ZM13 20V12H10V5C10 3.61667 10.4875 2.4375 11.4625 1.4625C12.4375 0.4875 13.6167 0 15 0V20H13Z"
    fill="#6F2519"
  />
</svg>`

export const housingIcon = html`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="20"
  height="18"
  viewBox="0 0 20 18"
  fill="none"
>
  <path
    d="M3 17.5V9.5H0L10 0.5L14 4.1V1.5H17V6.8L20 9.5H17V17.5H11V11.5H9V17.5H3ZM5 15.5H7V9.5H13V15.5H15V7.7L10 3.2L5 7.7V15.5ZM8 7.525H12C12 6.99167 11.8 6.55417 11.4 6.2125C11 5.87083 10.5333 5.7 10 5.7C9.46667 5.7 9 5.87083 8.6 6.2125C8.2 6.55417 8 6.99167 8 7.525Z"
    fill="#6F2519"
  />
</svg>`

export const jobsIcon = html`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
>
  <mask id="mask0_577_2285" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <rect width="24" height="24" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_577_2285)">
    <path
      d="M4 21C3.45 21 2.97917 20.8042 2.5875 20.4125C2.19583 20.0208 2 19.55 2 19V8C2 7.45 2.19583 6.97917 2.5875 6.5875C2.97917 6.19583 3.45 6 4 6H8V4C8 3.45 8.19583 2.97917 8.5875 2.5875C8.97917 2.19583 9.45 2 10 2H14C14.55 2 15.0208 2.19583 15.4125 2.5875C15.8042 2.97917 16 3.45 16 4V6H20C20.55 6 21.0208 6.19583 21.4125 6.5875C21.8042 6.97917 22 7.45 22 8V19C22 19.55 21.8042 20.0208 21.4125 20.4125C21.0208 20.8042 20.55 21 20 21H4ZM4 19H20V8H4V19ZM10 6H14V4H10V6Z"
      fill="#6F2519"
    />
  </g>
</svg>`

export const legalIcon = html`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="19"
  height="20"
  viewBox="0 0 19 20"
  fill="none"
>
  <path
    d="M0 20V17.8947H12.6316V20H0ZM5.94737 14.8947L0 8.94737L2.21053 6.68421L8.21053 12.6316L5.94737 14.8947ZM12.6316 8.21053L6.68421 2.21053L8.94737 0L14.8947 5.94737L12.6316 8.21053ZM17.4737 18.9474L3.73684 5.21053L5.21053 3.73684L18.9474 17.4737L17.4737 18.9474Z"
    fill="#6F2519"
  />
</svg>`

export const medicalIcon = html`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
>
  <mask id="mask0_577_2293" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <rect width="24" height="24" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_577_2293)">
    <path
      d="M12 21C11.7 21 11.4125 20.9458 11.1375 20.8375C10.8625 20.7292 10.6167 20.5667 10.4 20.35L3.7 13.625C3.11667 13.0417 2.6875 12.375 2.4125 11.625C2.1375 10.875 2 10.0917 2 9.275C2 7.55833 2.55833 6.08333 3.675 4.85C4.79167 3.61667 6.18333 3 7.85 3C8.65 3 9.40417 3.15833 10.1125 3.475C10.8208 3.79167 11.45 4.23333 12 4.8C12.5333 4.23333 13.1542 3.79167 13.8625 3.475C14.5708 3.15833 15.325 3 16.125 3C17.7917 3 19.1875 3.61667 20.3125 4.85C21.4375 6.08333 22 7.55 22 9.25C22 10.0667 21.8583 10.85 21.575 11.6C21.2917 12.35 20.8667 13.0167 20.3 13.6L13.575 20.35C13.3583 20.5667 13.1167 20.7292 12.85 20.8375C12.5833 20.9458 12.3 21 12 21ZM13 8C13.1667 8 13.325 8.04167 13.475 8.125C13.625 8.20833 13.7417 8.31667 13.825 8.45L15.525 11H19.675C19.7917 10.7167 19.8792 10.4292 19.9375 10.1375C19.9958 9.84583 20.025 9.55 20.025 9.25C19.9917 8.1 19.6083 7.1125 18.875 6.2875C18.1417 5.4625 17.225 5.05 16.125 5.05C15.6083 5.05 15.1125 5.15 14.6375 5.35C14.1625 5.55 13.75 5.84167 13.4 6.225L12.725 6.95C12.6417 7.05 12.5333 7.12917 12.4 7.1875C12.2667 7.24583 12.1333 7.275 12 7.275C11.8667 7.275 11.7333 7.24583 11.6 7.1875C11.4667 7.12917 11.35 7.05 11.25 6.95L10.575 6.225C10.225 5.84167 9.81667 5.54167 9.35 5.325C8.88333 5.10833 8.38333 5 7.85 5C6.75 5 5.83333 5.42083 5.1 6.2625C4.36667 7.10417 4 8.1 4 9.25C4 9.55 4.025 9.84583 4.075 10.1375C4.125 10.4292 4.20833 10.7167 4.325 11H9C9.16667 11 9.325 11.0417 9.475 11.125C9.625 11.2083 9.74167 11.3167 9.825 11.45L10.7 12.75L12.05 8.7C12.1167 8.5 12.2375 8.33333 12.4125 8.2C12.5875 8.06667 12.7833 8 13 8ZM13.3 11.25L11.95 15.3C11.8833 15.5 11.7583 15.6667 11.575 15.8C11.3917 15.9333 11.1917 16 10.975 16C10.8083 16 10.65 15.9583 10.5 15.875C10.35 15.7917 10.2333 15.6833 10.15 15.55L8.45 13H5.9L11.825 18.925C11.8583 18.9583 11.8875 18.9792 11.9125 18.9875C11.9375 18.9958 11.9667 19 12 19C12.0333 19 12.0625 18.9958 12.0875 18.9875C12.1125 18.9792 12.1417 18.9583 12.175 18.925L18.075 13H15C14.8333 13 14.675 12.9583 14.525 12.875C14.375 12.7917 14.25 12.6833 14.15 12.55L13.3 11.25Z"
      fill="#6F2519"
    />
  </g>
</svg>`

export const mentalHealthIcon = html`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
>
  <path
    d="M9.275 13.525C10.4417 13.525 11.4333 13.15 12.25 12.4C13.0667 11.65 13.475 10.7417 13.475 9.675C13.475 8.725 13.1708 7.92083 12.5625 7.2625C11.9542 6.60417 11.2167 6.275 10.35 6.275C9.56667 6.275 8.90417 6.525 8.3625 7.025C7.82083 7.525 7.55 8.14167 7.55 8.875C7.55 9.19167 7.6125 9.5 7.7375 9.8C7.8625 10.1 8.04167 10.375 8.275 10.625L9.7 9.2C9.65 9.16667 9.6125 9.125 9.5875 9.075C9.5625 9.025 9.55 8.96667 9.55 8.9C9.55 8.71667 9.625 8.57083 9.775 8.4625C9.925 8.35417 10.1167 8.3 10.35 8.3C10.6833 8.3 10.9583 8.4375 11.175 8.7125C11.3917 8.9875 11.5 9.31667 11.5 9.7C11.5 10.2167 11.2875 10.6542 10.8625 11.0125C10.4375 11.3708 9.91667 11.55 9.3 11.55C8.51667 11.55 7.85417 11.2333 7.3125 10.6C6.77083 9.96667 6.5 9.19167 6.5 8.275C6.5 7.79167 6.59167 7.32917 6.775 6.8875C6.95833 6.44583 7.21667 6.05833 7.55 5.725L6.125 4.3C5.59167 4.81667 5.18333 5.41667 4.9 6.1C4.61667 6.78333 4.475 7.5 4.475 8.25C4.475 9.71667 4.94167 10.9625 5.875 11.9875C6.80833 13.0125 7.94167 13.525 9.275 13.525ZM3 20V15.7C2.05 14.8333 1.3125 13.8208 0.7875 12.6625C0.2625 11.5042 0 10.2833 0 9C0 6.5 0.875 4.375 2.625 2.625C4.375 0.875 6.5 0 9 0C11.0833 0 12.9292 0.6125 14.5375 1.8375C16.1458 3.0625 17.1917 4.65833 17.675 6.625L18.975 11.75C19.0583 12.0667 19 12.3542 18.8 12.6125C18.6 12.8708 18.3333 13 18 13H16V16C16 16.55 15.8042 17.0208 15.4125 17.4125C15.0208 17.8042 14.55 18 14 18H12V20H10V16H14V11H16.7L15.75 7.125C15.3667 5.60833 14.55 4.375 13.3 3.425C12.05 2.475 10.6167 2 9 2C7.06667 2 5.41667 2.675 4.05 4.025C2.68333 5.375 2 7.01667 2 8.95C2 9.95 2.20417 10.9 2.6125 11.8C3.02083 12.7 3.6 13.5 4.35 14.2L5 14.8V20H3Z"
    fill="#6F2519"
  />
</svg>`

export const financialIcon = html`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
>
  <mask id="mask0_577_2301" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <rect width="24" height="24" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_577_2301)">
    <path
      d="M5 17V10H7V17H5ZM11 17V10H13V17H11ZM2 21V19H22V21H2ZM17 17V10H19V17H17ZM2 8V6L12 1L22 6V8H2ZM6.45 6H17.55L12 3.25L6.45 6Z"
      fill="#6F2519"
    />
  </g>
</svg>`

export const websiteIcon = html`<svg
  width="12"
  height="12"
  viewBox="0 0 12 12"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <mask id="mask0_219_2522" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="12" height="12">
    <rect width="12" height="12" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_219_2522)">
    <path
      d="M0 10V9H2V8.5C1.725 8.5 1.48958 8.40208 1.29375 8.20625C1.09792 8.01042 1 7.775 1 7.5V2.5C1 2.225 1.09792 1.98958 1.29375 1.79375C1.48958 1.59792 1.725 1.5 2 1.5H10C10.275 1.5 10.5104 1.59792 10.7063 1.79375C10.9021 1.98958 11 2.225 11 2.5V7.5C11 7.775 10.9021 8.01042 10.7063 8.20625C10.5104 8.40208 10.275 8.5 10 8.5V9H12V10H0ZM2 7.5H10V2.5H2V7.5Z"
      fill="#6F2519"
    />
  </g>
</svg> `

export const upArrowIcon = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <mask id="mask0_683_1566" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <rect width="24" height="24" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_683_1566)">
    <path d="M7.4 15.375L6 13.975L12 7.97498L18 13.975L16.6 15.375L12 10.775L7.4 15.375Z" fill="#7E7E7E" />
  </g>
</svg> `
